import { useCallback, useEffect, useRef, useState } from "react";
import "./App.css";

const API_URL = process.env.REACT_APP_API_URL || window.location.origin;

const fallbackSite = {
  hero: {
    eyebrow: "KTool Addin",
    title: "Design & Drafting",
    description:
      "Landing page động có backend riêng để quản lý nội dung, công cụ, bảng giá và yêu cầu tư vấn.",
    primaryAction: "Khám phá KTool",
    secondaryAction: "Gửi yêu cầu tư vấn dịch vụ",
    stats: [
      { value: "Nhanh chóng", label: "Tối ưu hóa hiệu suất, tiết kiệm thời gian làm việc lên đến 70% so với thao tác thủ công." },
      { value: "Chính xác", label: "Giảm thiểu sai sót với thuật toán kiểm tra thông minh, đảm bảo chất lượng dự án." },
      { value: "Dễ sử dụng", label: "Giao diện thân thiện, dễ học và sử dụng ngay cả với người mới bắt đầu." },
      { value: "Cập nhật liên tục", label: "Luôn được cập nhật tính năng mới và hỗ trợ các phiên bản Revit mới nhất." },
    ],
  },
  services: [],
  tools: [],
  pricing: [],
  testimonials: [],
  posts: [],
};

const iconMap = {
  install: "IN",
  code: "API",
  learn: "EDU",
  document: "DOC",
};

const serviceIconImages = {
  install: "/Install.png",
  code: "/Dev.png",
  learn: "/Edu.png",
  document: "/Shopdraw.png",
};

const servicePreviewImages = {
  install: "/PreviewKTool.png",
  code: "/PreviewDevAddin.png",
  learn: "/PreviewLearn.png",
  document: "/PreviewShopdraw.png",
};

const serviceRoutes = {
  install: "/KTool",
  code: "/API",
  learn: "/Learn",
  document: "/Drafting",
};

const ktoolZaloGroupUrl = "https://zalo.me/g/lzmptt656";
const ktoolDownloadUrl = "/download/ktool-installer/latest";
const ktoolInstallVideoUrl =
  "https://www.youtube.com/watch?v=j3ks1rx27zE";
const ktoolInstallVideoThumb = "https://i.ytimg.com/vi/CvR8QhiTO5A/hqdefault.jpg";

const ktoolFeatureGroups = [
  {
    title: "Auto Support/Hanger",
    description: "Tự động đặt vị trí treo giá đỡ dạng U,V theo vị trí đối tượng MEPF.",
    videoUrl: "https://www.youtube.com/watch?v=cfRsnxghEEo",
    images: [
      { src: "/PreviewRecMEPHanger.png", alt: "Rectangular MEP Hanger" },
      { src: "/PreviewRoundMEPHanger.png", alt: "Round MEP Hanger" },
      { src: "/PreviewRoundMultiHanger.png", alt: "Round Multi Hanger" },
      { src: "/PreviewMultiMEPHanger.png", alt: "Multi MEP Hanger" },
    ],
  },
  {
    title: "Auto Avoid",
    description: "Tự động lượn né các đối tượng MEPF với góc lượn và kiểu lượn khác nhau.",
    videoUrl: "https://www.youtube.com/watch?v=dQAEebwBBVo",
    images: [{ src: "/PreviewAvoid.png", alt: "Auto Avoid" }],
  },
  {
    title: "Extend",
    description: "Tự động tạo các đoạn MEPF theo chiều, hướng chọn sẵn.",
    videoUrl: "https://www.youtube.com/watch?v=cmzqsd0U7eQ",
    images: [
      { src: "/Bloom32.png", alt: "Bloom" },
      { src: "/ElbowDown32.png", alt: "ElbowDown" },
      { src: "/ElbowUp32.png", alt: "ElbowUp" },
      { src: "/ElbowRight32.png", alt: "ElbowRight" },
      { src: "/ElbowLeft32.png", alt: "ElbowLeft" },
      { src: "/ElbowUp4532.png", alt: "ElbowUp45" },
      { src: "/ElbowDown4532.png", alt: "ElbowDown45" },
    ],
  },
  {
    title: "Connect",
    description: "Tự động connect, disconnect, move, align để kết nối nhanh các đối tượng MEPF.",
    videoUrl: "https://www.youtube.com/watch?v=sP3jRtE45vc",
    images: [
      { src: "/DisconnectLT.png", alt: "Disconnect" },
      { src: "/MoveConnectLT.png", alt: "Move Connect" },
      { src: "/Mo-Co-ConnectLT.png", alt: "Mo-Co Connect" },
      { src: "/Align3DLT.png", alt: "Align 3D" },
      { src: "/AlignBranchLT.png", alt: "Align Branch" },
      { src: "/AlignBranch+LT.png", alt: "Align Branch +" },
    ],
  },
  {
    title: "Auto Place Family",
    description: "Tự động đặt family theo Block từ link CAD.",
    videoUrl: "https://www.youtube.com/watch?v=7EM0nCpVobs",
    images: [{ src: "/PreviewPlaceFamily.png", alt: "Auto Place Family" }],
  },
  {
    title: "View Copy",
    description: "Tạo view mới từ view đang mở, cho phép chuyển level của Associated Level và tùy chọn copy Annotation.",
    videoUrl: "https://www.youtube.com/watch?v=B4RXKiZpuTU",
    images: [{ src: "/PreviewViewCopy.png", alt: "View Copy" }],
  },
  {
    title: "Clash Check",
    description: "Tự động kiểm tra va chạm theo category, level, project; xem trực tiếp điểm va chạm và chỉnh sửa ngay trên view.",
    videoUrl: "https://www.youtube.com/watch?v=qTwIb1S35UE",
    images: [{ src: "/PreviewClashCheck.png", alt: "Clash Check" }],
  },
  {
    title: "Connect Sprinkler",
    description: "Tự động kết nối hàng loạt các đầu phun chữa cháy với ống chính bằng nhiều phương pháp khác nhau.",
    videoUrl: "https://www.youtube.com/watch?v=m7GNZ0DvBjQ",
    images: [{ src: "/PreviewConnectSprinkler.png", alt: "Connect Sprinkler" }],
  },
  {
    title: "Plumbing Tools",
    description: "Tự động kết nhánh với ống chính bằng nhiều phương pháp khác nhau.",
    videoUrl: "https://www.youtube.com/watch?v=MEV0aAgwCCc",
    images: [{ src: "/PreviewPlumbing.png", alt: "Plumbing Tools" }],
  },
];

const routeDetails = {
  "/KTool": {
    eyebrow: "KTool Addin",
    title: "KTool Addin",
    text: "Bộ công cụ hỗ trợ Shopdrawing MEPF và triển khai Revit tự động cho quy trình thực tế.",
  },
  "/API": {
    eyebrow: "Revit API C# & WPF",
    title: "PHÁT TRIỂN REVIT ADDIN THEO YÊU CẦU",
    text: "Tư vấn và phát triển Revit Addin theo nhu cầu thực tế của cá nhân, doanh nghiệp và đội ngũ BIM/MEPF. Giúp tự động hóa quy trình làm việc, giảm thao tác thủ công, tăng tốc độ triển khai mô hình và chuẩn hóa dữ liệu dự án trong Revit.",
    services: [
      "Phân tích workflow và quy trình nội bộ",
      "Phát triển Addin riêng theo yêu cầu",
      "Tự động hóa Modeling / Shopdrawing / BOM",
      "Quản lý dữ liệu và tiêu chuẩn BIM",
      "Tạo công cụ hỗ trợ QA/QC, kiểm tra clash, rename, tagging...",
      "Tối ưu thao tác Revit cho kỹ sư và BIM Modeler",
    ],
    values: [
      "Tiết kiệm thời gian triển khai dự án",
      "Giảm lỗi thao tác thủ công",
      "Chuẩn hóa quy trình công ty",
      "Tăng hiệu suất đội nhóm BIM",
      "Biến workflow thực tế thành công cụ sử dụng lâu dài",
    ],
    audiences: [
      "Công ty tư vấn thiết kế",
      "Nhà thầu MEP",
      "Đội ngũ BIM nội bộ",
      "BIM Freelancer",
      "Kỹ sư muốn tối ưu quy trình Revit",
    ],
    deliverables: [
      "Revit API Addin",
      "Auto Tool cho Revit MEPF",
      "Addin quản lý Family / Sheet / View",
      "Tool bóc tách khối lượng",
      "Tool Shopdrawing tự động",
      "Tool kiểm tra mô hình BIM",
      "Addin theo tiêu chuẩn riêng doanh nghiệp",
    ],
  },
  "/Learn": {
    title: "KHÓA HỌC REVIT MEPF",
    subtitle: "BIM Modeling | Shopdrawing | Design & Drafting",
    text: "Khóa học Revit MEPF được xây dựng theo quy trình BIM thực tế, tập trung vào triển khai hồ sơ kỹ thuật, dựng mô hình và Shopdrawing MEPF cho dự án dân dụng & công nghiệp. Học viên được thực hành trực tiếp trên project thực tế từ cơ bản đến nâng cao, phù hợp cho kỹ sư MEP, BIM Modeler và người mới bắt đầu với Revit MEPF.",
    modules: [
      {
        title: "Khởi tạo & làm quen phần mềm Revit",
        items: ["Giao diện và môi trường làm việc", "Thiết lập Project", "View 2D, 3D, Section", "Thiết lập Grid & Level"],
      },
      {
        title: "Khởi tạo dự án & Liên kết CAD",
        items: ["Liên kết CAD đúng chuẩn", "Đồng bộ tọa độ CAD - Revit", "Quản lý Layer, Color, Transparency", "Quy chuẩn lưu file CAD"],
      },
      {
        title: "Lý thuyết chung về hệ thống MEPF",
        items: ["Giới thiệu hệ thống HVAC, Plumbing, Fire Fighting, Electrical", "Đọc bản vẽ và dữ liệu đầu vào", "Tiêu chuẩn thiết kế MEPF"],
      },
      {
        title: "Triển khai mô hình MEPF",
        items: ["Thiết lập System", "Routing Preferences", "View Template", "Phân vùng và quản lý hệ thống"],
      },
      {
        title: "Hệ thống ống gió (HVAC)",
        items: ["Duct & Duct Systems", "Fitting và kết nối", "Chia khổ ống gió", "Triển khai hệ HVAC"],
      },
      {
        title: "Hệ thống ống nước (Plumbing)",
        items: ["Pipe & Pipe Systems", "Vẽ ống có slope", "Thiết lập hệ cấp thoát nước", "Quản lý vật liệu và kích thước ống"],
      },
      {
        title: "Phần Electrical",
        items: ["Cable Tray & Conduit", "Lighting Fixtures", "Power System", "Đi dây và bố trí thiết bị"],
      },
      {
        title: "Quản lý đối tượng trong dự án",
        items: ["Visibility / Graphic", "Filter & View Filter", "Override Graphic in View", "Quản lý hiển thị mô hình"],
      },
      {
        title: "Quản lý dự án BIM",
        items: ["Combine hệ thống", "Phối hợp bộ môn", "Không gian vận hành", "Tối ưu kỹ thuật & thẩm mỹ"],
      },
      {
        title: "Clash Detection & Shopdrawing",
        items: ["Navisworks Coordination", "Clash Detection", "Triển khai Shopdrawing", "Trình bày bản vẽ & In ấn"],
      },
      {
        title: "Family & Addin hỗ trợ",
        items: ["Family cơ bản", "Addin hỗ trợ Revit MEPF", "Bóc tách khối lượng", "Cloud & quản lý dữ liệu BIM"],
      },
    ],
    outcomes: [
      "Thành thạo dựng model Revit MEPF",
      "Tự triển khai hồ sơ kỹ thuật & Shopdrawing",
      "Hiểu quy trình BIM thực tế dự án",
      "Phối hợp hiệu quả giữa các bộ môn",
      "Sẵn sàng làm BIM Modeler / BIM MEP Engineer",
    ],
    support: [
      "Nhận triển khai outsource Revit MEPF",
      "Dựng model BIM & Shopdrawing MEP",
      "Hỗ trợ kỹ thuật sau khóa học",
    ],
    contact: {
      hotline: "0969860511",
      email: "vantu1236744@gmail.com",
      website: "KToolBim.com",
    },
    images: [
      { src: "/learn/learn-model-01.jpg", alt: "Mô hình BIM MEPF tổng thể" },
      { src: "/learn/learn-model-02.jpg", alt: "Mặt cắt phối hợp hệ MEPF" },
      { src: "/learn/learn-shopdrawing-03.jpg", alt: "Bản vẽ shopdrawing MEPF" },
      { src: "/learn/learn-overview-04.jpg", alt: "Tổng quan hệ thống trong tòa nhà" },
    ],
  },
  "/Drafting": {
    eyebrow: "Drafting",
    title: "TRIỂN KHAI HỒ SƠ KỸ THUẬT & SHOPDRAWING MEPF",
    text: "Chuyên triển khai hồ sơ kỹ thuật, Shopdrawing MEP và dựng mô hình Revit MEPF theo tiêu chuẩn BIM thực tế cho dự án dân dụng, thương mại và công nghiệp. Nhận outsource Revit MEPF từ giai đoạn modeling, phối hợp bộ môn đến hoàn thiện bản vẽ thi công và hồ sơ kỹ thuật.",
    services: [
      "Dựng mô hình BIM Revit MEPF",
      "Triển khai Shopdrawing MEP",
      "Hồ sơ kỹ thuật thi công",
      "HVAC - Plumbing - Fire Fighting - Electrical",
      "Clash Detection & BIM Coordination",
      "Bóc tách khối lượng (BOQ)",
      "Xuất bản vẽ và quản lý dữ liệu BIM",
    ],
    process: [
      "Tiếp nhận bản vẽ & yêu cầu dự án",
      "Dựng mô hình Revit MEPF theo tiêu chuẩn",
      "Phối hợp và kiểm tra xung đột hệ thống",
      "Triển khai Shopdrawing & hồ sơ kỹ thuật",
      "Bàn giao model, bản vẽ và dữ liệu hoàn chỉnh",
    ],
    values: [
      "Tăng tốc độ triển khai dự án",
      "Giảm xung đột giữa các bộ môn",
      "Chuẩn hóa hồ sơ kỹ thuật BIM",
      "Hỗ trợ thi công và quản lý hiệu quả",
      "Tiết kiệm nhân sự và thời gian cho doanh nghiệp",
    ],
    outsource: [
      "Revit MEPF Modeling",
      "BIM Coordination",
      "Shopdrawing MEP",
      "As-built BIM Model",
      "Hồ sơ kỹ thuật thi công",
      "Hỗ trợ theo tiến độ dự án",
    ],
    customers: [
      "Công ty tư vấn thiết kế",
      "Nhà thầu MEP",
      "Tổng thầu xây dựng",
      "Đội ngũ BIM nội bộ",
      "Freelancer & đối tác kỹ thuật",
    ],
  },
};

const POSTS_PER_PAGE = 4;

const createPostSlug = (title) =>
  title
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

const paymentPlanKeys = ["Monthly", "Yearly", "Lifetime", "LearnCourse", "Custom"];

const paymentPlanOptions = [
  { value: "Monthly", label: "Gói tháng - 99.000đ" },
  { value: "Yearly", label: "Gói năm - 999.000đ" },
  { value: "Lifetime", label: "Vĩnh viễn - 6.999.000đ" },
  { value: "LearnCourse", label: "Khóa học Revit MEPF - 3.000.000đ" },
  { value: "Custom", label: "Tùy chọn số tiền" },
];

const planLabels = {
  Free: "Free",
  Monthly: "gói tháng",
  Yearly: "gói năm",
  Lifetime: "gói vĩnh viễn",
};

planLabels.LearnCourse = "khóa học Revit MEPF";
planLabels.Custom = "thanh toán tùy chọn";

const autodeskProductMeta = {
  AutoCAD: { letter: "A", label: "CAD", color: "#d7193f" },
  Revit: { letter: "R", label: "RVT", color: "#1f6feb" },
};

const getPricingPlanKey = (plan) => {
  const text = `${plan?.name || ""} ${plan?.price || ""}`
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

  if (text.includes("6.999") || text.includes("vinh") || text.includes("lifetime")) return "Lifetime";
  if (text.includes("999.000") || text.includes("nam") || text.includes("year")) return "Yearly";
  if (text.includes("99.000") || text.includes("thang") || text.includes("month")) return "Monthly";
  return "Free";
};

const normalizeSelectedPlan = (plan) => {
  if (!plan) return "";
  return ["Free", ...paymentPlanKeys].includes(plan) ? plan : "";
};

const formatDate = (date) => {
  if (!date) return "Vô hạn";
  return new Date(date).toLocaleDateString("vi-VN");
};

const subscriptionStatusLabels = {
  active: "Còn hạn",
  paid: "Đã thanh toán",
  pending: "Đang chờ thanh toán",
  expired: "Hết hạn",
  paused: "Tạm khóa",
  amount_mismatch: "Sai số tiền",
  ignored: "Bo qua",
  failed: "That bai",
};

const emptyPostForm = {
  title: "",
  tag: "BIM",
  date: new Date().toISOString().slice(0, 10),
  excerpt: "",
  content: "",
};

const hasHtmlContent = (content = "") => /<\/?[a-z][\s\S]*>/i.test(content);

const normalizeVideoUrl = (url = "") => {
  try {
    const parsedUrl = new URL(url);
    if (parsedUrl.hostname.includes("youtube.com")) {
      const videoId = parsedUrl.searchParams.get("v");
      return videoId ? `https://www.youtube.com/embed/${videoId}` : url;
    }
    if (parsedUrl.hostname.includes("youtu.be")) {
      const videoId = parsedUrl.pathname.replace("/", "");
      return videoId ? `https://www.youtube.com/embed/${videoId}` : url;
    }
    return url;
  } catch (error) {
    return url;
  }
};

function App() {
  const [site, setSite] = useState(fallbackSite);
  const [lead, setLead] = useState({ name: "", email: "", phone: "", need: "" });
  const [status, setStatus] = useState({ type: "idle", message: "" });
  const [activeImage, setActiveImage] = useState(null);
  const [activeVideo, setActiveVideo] = useState(null);
  const [ktoolInstaller, setKtoolInstaller] = useState({
    fileName: "KTool_Installer_V1.0.0.zip",
    downloadUrl: ktoolDownloadUrl,
  });
  const [account, setAccount] = useState(() => {
    try {
      const savedAccount = localStorage.getItem("ktoolAccount");
      return savedAccount ? JSON.parse(savedAccount) : null;
    } catch (error) {
      return null;
    }
  });
  const [authMode, setAuthMode] = useState("login");
  const [authForm, setAuthForm] = useState({ name: "", email: "", password: "" });
  const [authStatus, setAuthStatus] = useState({ type: "idle", message: "" });
  const [adminUsers, setAdminUsers] = useState([]);
  const [adminFilters, setAdminFilters] = useState({ name: "", email: "" });
  const [adminStatus, setAdminStatus] = useState({ type: "idle", message: "" });
  const [adminLeads, setAdminLeads] = useState([]);
  const [adminLeadFilters, setAdminLeadFilters] = useState({ search: "", status: "" });
  const [adminLeadStatus, setAdminLeadStatus] = useState({ type: "idle", message: "" });
  const [adminPosts, setAdminPosts] = useState([]);
  const [adminPostForm, setAdminPostForm] = useState(emptyPostForm);
  const [editingPostId, setEditingPostId] = useState(null);
  const [adminPostStatus, setAdminPostStatus] = useState({ type: "idle", message: "" });
  const [adminEditorKey, setAdminEditorKey] = useState(0);
  const postEditorRef = useRef(null);
  const adminPostContentRef = useRef(emptyPostForm.content);
  const postImageInputRef = useRef(null);
  const selectedEditorImageRef = useRef(null);
  const [commentText, setCommentText] = useState("");
  const [replyTexts, setReplyTexts] = useState({});
  const [commentStatus, setCommentStatus] = useState({ type: "idle", message: "" });
  const [showReviewForm, setShowReviewForm] = useState(false);
  const [reviewForm, setReviewForm] = useState({ name: "", role: "", quote: "" });
  const [editingReviewId, setEditingReviewId] = useState(null);
  const [reviewStatus, setReviewStatus] = useState({ type: "idle", message: "" });
  const testimonialTrackRef = useRef(null);
  const [paymentStatus, setPaymentStatus] = useState({ type: "idle", message: "" });
  const [selectedPlan, setSelectedPlan] = useState("Monthly");
  const [customAmount, setCustomAmount] = useState("");
  const [currentPayment, setCurrentPayment] = useState(null);
  const [profileForm, setProfileForm] = useState({
    username: "",
    email: "",
    name: "",
    password: "",
    passwordConfirm: "",
  });
  const [profileStatus, setProfileStatus] = useState({ type: "idle", message: "" });
  const [subscriptions, setSubscriptions] = useState([]);
  const [accountTab, setAccountTab] = useState("tracking");
  const [deviceInfo, setDeviceInfo] = useState({ activeDevice: null, addinSessions: [], license: null });
  const [deviceStatus, setDeviceStatus] = useState({ type: "idle", message: "" });
  const [autodeskProducts, setAutodeskProducts] = useState([]);
  const [autodeskSelection, setAutodeskSelection] = useState({ product: "AutoCAD", year: "", part: "" });
  const [autodeskStatus, setAutodeskStatus] = useState({ type: "idle", message: "" });
  const [canDownloadAutodesk, setCanDownloadAutodesk] = useState(false);

  useEffect(() => {
    async function loadSite() {
      try {
        const response = await fetch(`${API_URL}/api/site`);
        const data = await response.json();
        setSite(data);
      } catch (error) {
        setStatus({
          type: "warning",
          message: "Đang hiển thị dữ liệu mẫu vì backend chưa sẵn sàng.",
        });
      }
    }

    loadSite();
  }, []);

  useEffect(() => {
    async function loadAutodeskDownloads() {
      try {
        const response = await fetch(`${API_URL}/api/autodesk-downloads`, {
          headers: account?.token ? { Authorization: `Bearer ${account.token}` } : {},
        });
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message || "Không thể tải dữ liệu Autodesk.");
        }

        setAutodeskProducts(data.products || []);
        setCanDownloadAutodesk(Boolean(data.canDownload));
      } catch (error) {
        setCanDownloadAutodesk(false);
        setAutodeskStatus({
          type: "error",
          message: error.message || "Không thể tải dữ liệu Autodesk.",
        });
      }
    }

    loadAutodeskDownloads();
  }, [account?.token]);

  useEffect(() => {
    if (!autodeskProducts.length) return;

    const currentProduct =
      autodeskProducts.find((product) => product.key === autodeskSelection.product) ||
      autodeskProducts[0];
    const currentYear =
      currentProduct.years.find((yearItem) => yearItem.year === autodeskSelection.year) ||
      currentProduct.years[0];
    const currentPart =
      currentYear?.parts.find((partItem) => partItem.part === autodeskSelection.part) ||
      currentYear?.parts[0];

    const nextSelection = {
      product: currentProduct.key,
      year: currentYear?.year || "",
      part: currentPart?.part || "",
    };

    if (
      nextSelection.product !== autodeskSelection.product ||
      nextSelection.year !== autodeskSelection.year ||
      nextSelection.part !== autodeskSelection.part
    ) {
      setAutodeskSelection(nextSelection);
    }
  }, [autodeskProducts, autodeskSelection.product, autodeskSelection.year, autodeskSelection.part]);

  useEffect(() => {
    if (!activeImage && !activeVideo) return undefined;

    const closeOnEscape = (event) => {
      if (event.key === "Escape") {
        setActiveImage(null);
        setActiveVideo(null);
      }
    };

    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [activeImage, activeVideo]);

  useEffect(() => {
    async function loadKtoolInstaller() {
      try {
        const response = await fetch(`${API_URL}/api/ktool-installer`);
        if (!response.ok) return;
        const data = await response.json();
        setKtoolInstaller({
          fileName: data.fileName || "KTool_Installer_V1.0.0.zip",
          downloadUrl: data.downloadUrl || ktoolDownloadUrl,
        });
      } catch (error) {
        setKtoolInstaller({
          fileName: "KTool_Installer_V1.0.0.zip",
          downloadUrl: ktoolDownloadUrl,
        });
      }
    }

    loadKtoolInstaller();
  }, []);

  useEffect(() => {
    if (!account?.token) return undefined;

    async function refreshAccount() {
      try {
        const response = await fetch(`${API_URL}/api/auth/me`, {
          headers: { Authorization: `Bearer ${account.token}` },
        });

        if (!response.ok) {
          throw new Error("Phiên đăng nhập hết hạn.");
        }

        const data = await response.json();
        const refreshedAccount = { token: account.token, user: data.user };
        localStorage.setItem("ktoolAccount", JSON.stringify(refreshedAccount));
        setAccount(refreshedAccount);
      } catch (error) {
        localStorage.removeItem("ktoolAccount");
        setAccount(null);
      }
    }

    refreshAccount();
  }, [account?.token]);

  useEffect(() => {
    if (!account?.user) return;

    setProfileForm((current) => ({
      ...current,
      username: account.user.username || account.user.email?.split("@")[0] || "",
      email: account.user.email || "",
      name: account.user.name || "",
      password: "",
      passwordConfirm: "",
    }));
    setReviewForm((current) => ({
      ...current,
      name: current.name || account.user.name || account.user.username || "",
    }));
  }, [account?.user]);

  const loadSubscriptions = useCallback(async () => {
    if (!account?.token) return;

    try {
      const response = await fetch(`${API_URL}/api/account/subscriptions`, {
        headers: { Authorization: `Bearer ${account.token}` },
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Không thể tải danh sách gói.");
      }
      setSubscriptions(data.subscriptions || []);
    } catch (error) {
      setProfileStatus({ type: "warning", message: error.message });
    }
  }, [account?.token]);

  useEffect(() => {
    loadSubscriptions();
  }, [loadSubscriptions]);

  const loadMyDevices = useCallback(async () => {
    if (!account?.token) {
      setDeviceStatus({ type: "warning", message: "Cần đăng nhập để quản lý thiết bị." });
      return;
    }

    setDeviceStatus({ type: "loading", message: "Đang tải thiết bị..." });

    try {
      const response = await fetch(`${API_URL}/api/account/devices`, {
        headers: { Authorization: `Bearer ${account.token}` },
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Không thể tải danh sách thiết bị.");
      }

      setDeviceInfo({
        activeDevice: data.activeDevice || null,
        addinSessions: data.addinSessions || [],
        license: data.license || null,
      });
      setDeviceStatus({ type: "success", message: "" });
    } catch (error) {
      setDeviceStatus({ type: "error", message: error.message });
    }
  }, [account?.token]);

  useEffect(() => {
    const currentPath = window.location.pathname.replace(/\/$/, "").toLowerCase() || "/";
    if (currentPath !== "/my-devices") return;
    loadMyDevices();
  }, [loadMyDevices]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const authToken = params.get("authToken");
    const authError = params.get("authError");
    const pendingPlan = normalizeSelectedPlan(localStorage.getItem("ktoolPendingPlan"));

    if (!authToken && !authError) return;

    window.history.replaceState({}, "", pendingPlan ? `/Account?plan=${pendingPlan}` : "/Account");

    if (authError) {
      setAuthStatus({ type: "error", message: authError });
      return;
    }

    async function loadGoogleAccount() {
      setAuthStatus({ type: "loading", message: "Đang hoàn tất đăng nhập Google..." });

      try {
        const response = await fetch(`${API_URL}/api/auth/me`, {
          headers: { Authorization: `Bearer ${authToken}` },
        });
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message || "Không thể xac thuc tài khoản Google.");
        }

        const nextAccount = { token: authToken, user: data.user };
        localStorage.setItem("ktoolAccount", JSON.stringify(nextAccount));
        setAccount(nextAccount);
        setAuthStatus({ type: "success", message: "Đăng nhập Google thành công." });
      } catch (error) {
        setAuthStatus({ type: "error", message: error.message });
      }
    }

    loadGoogleAccount();
  }, []);

  useEffect(() => {
    const currentPath = window.location.pathname.replace(/\/$/, "") || "/";
    if (currentPath !== "/Account") return;

    const params = new URLSearchParams(window.location.search);
    const planFromUrl = normalizeSelectedPlan(params.get("plan")) || normalizeSelectedPlan(localStorage.getItem("ktoolPendingPlan"));

    if (!planFromUrl) return;

    localStorage.setItem("ktoolPendingPlan", planFromUrl);

    if (paymentPlanKeys.includes(planFromUrl)) {
      setSelectedPlan(planFromUrl);
    }

    if (!account?.user) {
      setAuthMode("login");
      setAuthStatus({
        type: "warning",
        message: `Vui lòng đăng nhập để đăng ký ${planLabels[planFromUrl]}.`,
      });
      return;
    }

    if (planFromUrl === "Free") {
      setPaymentStatus({
        type: "success",
        message: "Gói Free không cần thanh toán SePay. Tài khoản của bạn có thể dùng gói Free mặc định.",
      });
      return;
    }

    setPaymentStatus({
      type: "success",
      message: `Đã chọn ${planLabels[planFromUrl]}. Bấm tạo QR để thanh toán.`,
    });
  }, [account?.user]);

  const loadAdminUsers = useCallback(async () => {
    if (!account?.token) {
      setAdminStatus({ type: "error", message: "Cần đăng nhập bằng email admin để xem trang này." });
      return;
    }

    setAdminStatus({ type: "loading", message: "Đang tải danh sách tài khoản..." });

    try {
      const response = await fetch(`${API_URL}/api/admin/users`, {
        headers: { Authorization: `Bearer ${account.token}` },
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Không thể tải danh sách tài khoản.");
      }

      setAdminUsers(data.users || []);
      setAdminStatus({ type: "success", message: "" });
    } catch (error) {
      setAdminStatus({ type: "error", message: error.message });
    }
  }, [account?.token]);

  useEffect(() => {
    const currentPath = window.location.pathname.replace(/\/$/, "") || "/";
    if (currentPath !== "/Admin/Users") return;
    loadAdminUsers();
  }, [loadAdminUsers]);

  const loadAdminLeads = useCallback(async () => {
    if (!account?.token) {
      setAdminLeadStatus({ type: "error", message: "Cần đăng nhập bằng email admin để xem yêu cầu tư vấn." });
      return;
    }

    setAdminLeadStatus({ type: "loading", message: "Đang tải danh sách yêu cầu tư vấn..." });

    try {
      const response = await fetch(`${API_URL}/api/admin/leads`, {
        headers: { Authorization: `Bearer ${account.token}` },
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Không thể tải danh sách yêu cầu tư vấn.");
      }

      setAdminLeads(data.leads || []);
      setAdminLeadStatus({ type: "success", message: "" });
    } catch (error) {
      setAdminLeadStatus({ type: "error", message: error.message });
    }
  }, [account?.token]);

  useEffect(() => {
    const currentPath = window.location.pathname.replace(/\/$/, "") || "/";
    if (currentPath !== "/Admin/Leads") return;
    loadAdminLeads();
  }, [loadAdminLeads]);

  const loadAdminPosts = useCallback(async () => {
    if (!account?.token) {
      setAdminPostStatus({ type: "error", message: "Cần đăng nhập bằng email admin để quản lý bài viết." });
      return;
    }

    setAdminPostStatus({ type: "loading", message: "Đang tải danh sách bài viết..." });

    try {
      const response = await fetch(`${API_URL}/api/admin/posts`, {
        headers: { Authorization: `Bearer ${account.token}` },
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Không thể tải danh sách bài viết.");
      }

      setAdminPosts(data.posts || []);
      setAdminPostStatus({ type: "success", message: "" });
    } catch (error) {
      setAdminPostStatus({ type: "error", message: error.message });
    }
  }, [account?.token]);

  useEffect(() => {
    const currentPath = window.location.pathname.replace(/\/$/, "") || "/";
    if (currentPath !== "/Admin/Posts") return;
    loadAdminPosts();
  }, [loadAdminPosts]);

  const updateAdminUser = async (userId, updates) => {
    setAdminStatus({ type: "loading", message: "Đang cập nhật user..." });

    try {
      const response = await fetch(`${API_URL}/api/admin/users/${userId}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${account.token}`,
        },
        body: JSON.stringify(updates),
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Không thể cập nhật người dùng.");
      }

      await loadAdminUsers();
      setAdminStatus({ type: "success", message: data.message });
    } catch (error) {
      setAdminStatus({ type: "error", message: error.message });
    }
  };

  const runAdminAction = async (userId, action, confirmMessage) => {
    if (confirmMessage && !window.confirm(confirmMessage)) return;

    setAdminStatus({ type: "loading", message: "Đang xử lý..." });

    try {
      const response = await fetch(`${API_URL}/api/admin/users/${userId}/${action}`, {
        method: "POST",
        headers: { Authorization: `Bearer ${account.token}` },
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Không thể xu ly thao tac.");
      }

      await loadAdminUsers();
      setAdminStatus({ type: "success", message: data.message });
    } catch (error) {
      setAdminStatus({ type: "error", message: error.message });
    }
  };

  const deleteAdminUser = async (userId, email) => {
    if (!window.confirm(`Xoá account ${email}? Thao tác này sẽ xoá user và tất cả session.`)) return;

    setAdminStatus({ type: "loading", message: "Đang xoá account..." });

    try {
      const response = await fetch(`${API_URL}/api/admin/users/${userId}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${account.token}` },
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Không thể xoá tài khoản.");
      }

      await loadAdminUsers();
      setAdminStatus({ type: "success", message: data.message });
    } catch (error) {
      setAdminStatus({ type: "error", message: error.message });
    }
  };

  const updateAdminLead = async (leadId, status) => {
    setAdminLeadStatus({ type: "loading", message: "Đang cập nhật yêu cầu tư vấn..." });

    try {
      const response = await fetch(`${API_URL}/api/admin/leads/${leadId}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${account.token}`,
        },
        body: JSON.stringify({ status }),
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Không thể cập nhật yêu cầu tư vấn.");
      }

      await loadAdminLeads();
      setAdminLeadStatus({ type: "success", message: data.message });
    } catch (error) {
      setAdminLeadStatus({ type: "error", message: error.message });
    }
  };

  const deleteAdminLead = async (lead) => {
    if (!window.confirm(`Xoá yêu cầu tư vấn của ${lead.name || lead.email}?`)) return;

    setAdminLeadStatus({ type: "loading", message: "Đang xoá yêu cầu tư vấn..." });

    try {
      const response = await fetch(`${API_URL}/api/admin/leads/${lead.id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${account.token}` },
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Không thể xoá yêu cầu tư vấn.");
      }

      await loadAdminLeads();
      setAdminLeadStatus({ type: "success", message: data.message });
    } catch (error) {
      setAdminLeadStatus({ type: "error", message: error.message });
    }
  };

  const refreshSite = async () => {
    const response = await fetch(`${API_URL}/api/site`);
    const data = await response.json();
    setSite(data);
  };

  const handleAdminPostChange = (event) => {
    const { name, value } = event.target;
    setAdminPostForm((current) => ({ ...current, [name]: value }));
  };

  const handleReviewChange = (event) => {
    const { name, value } = event.target;
    setReviewForm((current) => ({ ...current, [name]: value }));
  };

  const scrollTestimonials = (direction) => {
    const track = testimonialTrackRef.current;
    if (!track) return;
    const distance = Math.max(320, Math.round(track.clientWidth * 0.85));
    track.scrollBy({ left: direction * distance, behavior: "smooth" });
  };

  const openReviewForm = (testimonial = null) => {
    if (!account?.user) {
      window.location.href = "/Account";
      return;
    }

    if (testimonial) {
      setEditingReviewId(testimonial.id);
      setReviewForm({
        name: testimonial.name || account.user.name || account.user.username || "",
        role: testimonial.role || "",
        quote: testimonial.quote || "",
      });
    } else {
      setEditingReviewId(null);
      setReviewForm({
        name: account.user.name || account.user.username || "",
        role: "",
        quote: "",
      });
    }

    setShowReviewForm(true);
    setReviewStatus({ type: "idle", message: "" });
  };

  const resetAdminPostForm = () => {
    setEditingPostId(null);
    adminPostContentRef.current = emptyPostForm.content;
    setAdminPostForm(emptyPostForm);
    setAdminEditorKey((current) => current + 1);
    setAdminPostStatus({ type: "idle", message: "" });
  };

  const startEditAdminPost = (post) => {
    const nextContent = post.content || post.excerpt || "";
    setEditingPostId(post.id);
    adminPostContentRef.current = nextContent;
    setAdminPostForm({
      title: post.title || "",
      tag: post.tag || "BIM",
      date: post.date || new Date().toISOString().slice(0, 10),
      excerpt: post.excerpt || "",
      content: nextContent,
    });
    setAdminEditorKey((current) => current + 1);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const syncPostEditorContent = ({ updateState = true } = {}) => {
    const content = postEditorRef.current?.innerHTML || "";
    adminPostContentRef.current = content;
    if (!updateState) return;

    setAdminPostForm((current) => ({
      ...current,
      content,
    }));
  };

  const handlePostEditorInput = () => {
    syncPostEditorContent({ updateState: false });
  };

  const runPostEditorCommand = (command, value = null) => {
    postEditorRef.current?.focus();
    document.execCommand(command, false, value);
    syncPostEditorContent();
  };

  const insertEditorHtml = (html) => {
    postEditorRef.current?.focus();
    document.execCommand("insertHTML", false, html);
    syncPostEditorContent();
  };

  const insertPostImage = (url) => {
    if (!url) return;
    insertEditorHtml(`<img src="${url}" alt="" class="editor-image-center" draggable="true" />`);
  };

  const insertPostVideo = (url) => {
    if (!url) return;
    const videoUrl = normalizeVideoUrl(url);
    const isDirectVideo = /\.(mp4|webm|ogg)(\?.*)?$/i.test(videoUrl);
    const html = isDirectVideo
      ? `<video class="editor-video" src="${videoUrl}" controls></video>`
      : `<div class="editor-video"><iframe src="${videoUrl}" title="Video" allowfullscreen></iframe></div>`;
    insertEditorHtml(html);
  };

  const insertEditorShape = (shape) => {
    const shapeLabels = {
      rect: "",
      round: "",
      circle: "",
      triangle: "",
      star: "☆",
      arrow: "→",
      line: "",
    };
    insertEditorHtml(`<span class="editor-shape editor-shape-${shape}" contenteditable="false">${shapeLabels[shape] || ""}</span>`);
  };

  const applyEditorElementStyle = (property, value) => {
    const element = selectedEditorImageRef.current;
    if (!element) {
      setAdminPostStatus({ type: "warning", message: "Chọn ảnh hoặc shape trong nội dung trước khi đổi style." });
      return;
    }
    element.style[property] = value;
    syncPostEditorContent();
  };

  const selectEditorImage = (image) => {
    selectedEditorImageRef.current?.classList.remove("selected-editor-image");
    selectedEditorImageRef.current = image || null;
    selectedEditorImageRef.current?.classList.add("selected-editor-image");
  };

  const handleEditorClick = (event) => {
    const element = event.target.closest?.("img, .editor-shape");
    if (element && postEditorRef.current?.contains(element)) {
      selectEditorImage(element);
    }
  };

  const applySelectedImageLayout = (layout) => {
    const image = selectedEditorImageRef.current;
    if (!image) {
      setAdminPostStatus({ type: "warning", message: "Chọn ảnh trong nội dung trước khi đổi bố cục." });
      return;
    }

    image.classList.remove("editor-image-left", "editor-image-center", "editor-image-right", "editor-image-full");
    image.classList.add(`editor-image-${layout}`);
    syncPostEditorContent();
  };

  const removeSelectedImage = () => {
    const image = selectedEditorImageRef.current;
    if (!image) {
      setAdminPostStatus({ type: "warning", message: "Chọn ảnh cần xoá trong nội dung." });
      return;
    }

    image.remove();
    selectedEditorImageRef.current = null;
    syncPostEditorContent();
  };

  const uploadPostImage = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (!account?.token) {
      setAdminPostStatus({ type: "error", message: "Cần đăng nhập admin để tải ảnh." });
      return;
    }

    const formData = new FormData();
    formData.append("image", file);
    setAdminPostStatus({ type: "loading", message: "Đang tải ảnh..." });

    try {
      const response = await fetch(`${API_URL}/api/admin/uploads`, {
        method: "POST",
        headers: { Authorization: `Bearer ${account.token}` },
        body: formData,
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Không thể tải ảnh.");
      }

      insertPostImage(data.url);
      setAdminPostStatus({ type: "success", message: data.message });
    } catch (error) {
      setAdminPostStatus({ type: "error", message: error.message });
    } finally {
      event.target.value = "";
    }
  };

  const submitAdminPost = async (event) => {
    event.preventDefault();

    if (!account?.token) {
      setAdminPostStatus({ type: "error", message: "Cần đăng nhập admin để lưu bài viết." });
      return;
    }

    setAdminPostStatus({ type: "loading", message: "Đang lưu bài viết..." });
    const postPayload = {
      ...adminPostForm,
      content: postEditorRef.current?.innerHTML || adminPostContentRef.current || adminPostForm.content,
    };

    try {
      const response = await fetch(
        `${API_URL}/api/admin/posts${editingPostId ? `/${editingPostId}` : ""}`,
        {
          method: editingPostId ? "PATCH" : "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${account.token}`,
          },
          body: JSON.stringify(postPayload),
        }
      );
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Không thể luu bài viết.");
      }

      await loadAdminPosts();
      await refreshSite();
      setEditingPostId(null);
      adminPostContentRef.current = emptyPostForm.content;
      setAdminPostForm(emptyPostForm);
      setAdminEditorKey((current) => current + 1);
      setAdminPostStatus({ type: "success", message: data.message });
    } catch (error) {
      setAdminPostStatus({ type: "error", message: error.message });
    }
  };

  const deleteAdminPost = async (post) => {
    if (!window.confirm(`Xoá bài viết "${post.title}"?`)) return;

    setAdminPostStatus({ type: "loading", message: "Đang xoá bài viết..." });

    try {
      const response = await fetch(`${API_URL}/api/admin/posts/${post.id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${account.token}` },
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Không thể xoá bài viết.");
      }

      await loadAdminPosts();
      await refreshSite();
      setAdminPostStatus({ type: "success", message: data.message });
    } catch (error) {
      setAdminPostStatus({ type: "error", message: error.message });
    }
  };

  const submitPostComment = async (event) => {
    event.preventDefault();

    if (!account?.token) {
      setCommentStatus({ type: "error", message: "Cần đăng nhập để bình luận." });
      return;
    }

    if (!activePost?.id) {
      setCommentStatus({ type: "error", message: "Không tìm thấy bài viết." });
      return;
    }

    setCommentStatus({ type: "loading", message: "Đang gửi bình luận..." });

    try {
      const response = await fetch(`${API_URL}/api/posts/${activePost.id}/comments`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${account.token}`,
        },
        body: JSON.stringify({ content: commentText }),
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Không thể gui bình luận.");
      }

      setCommentText("");
      await refreshSite();
      setCommentStatus({ type: "success", message: data.message });
    } catch (error) {
      setCommentStatus({ type: "error", message: error.message });
    }
  };

  const deletePostComment = async (postId, commentId) => {
    if (!window.confirm("Xoá bình luận này?")) return;

    setCommentStatus({ type: "loading", message: "Đang xoá bình luận..." });

    try {
      const response = await fetch(`${API_URL}/api/posts/${postId}/comments/${commentId}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${account.token}` },
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Không thể xoá bình luận.");
      }

      await refreshSite();
      setCommentStatus({ type: "success", message: data.message });
    } catch (error) {
      setCommentStatus({ type: "error", message: error.message });
    }
  };

  const submitCommentReply = async (event, commentId) => {
    event.preventDefault();

    if (!account?.token) {
      setCommentStatus({ type: "error", message: "Cần đăng nhập để trả lời bình luận." });
      return;
    }

    const content = (replyTexts[commentId] || "").trim();
    if (!content) {
      setCommentStatus({ type: "warning", message: "Vui lòng nhập nội dung trả lời." });
      return;
    }

    setCommentStatus({ type: "loading", message: "Đang gửi trả lời..." });

    try {
      const response = await fetch(`${API_URL}/api/posts/${activePost.id}/comments/${commentId}/replies`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${account.token}`,
        },
        body: JSON.stringify({ content }),
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Không thể gui trả lời.");
      }

      setReplyTexts((current) => ({ ...current, [commentId]: "" }));
      await refreshSite();
      setCommentStatus({ type: "success", message: data.message });
    } catch (error) {
      setCommentStatus({ type: "error", message: error.message });
    }
  };

  const deleteCommentReply = async (postId, commentId, replyId) => {
    if (!window.confirm("Xoá trả lời này?")) return;

    setCommentStatus({ type: "loading", message: "Đang xoá trả lời..." });

    try {
      const response = await fetch(`${API_URL}/api/posts/${postId}/comments/${commentId}/replies/${replyId}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${account.token}` },
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Không thể xoá trả lời.");
      }

      await refreshSite();
      setCommentStatus({ type: "success", message: data.message });
    } catch (error) {
      setCommentStatus({ type: "error", message: error.message });
    }
  };

  const submitReview = async (event) => {
    event.preventDefault();

    if (!account?.token) {
      setReviewStatus({ type: "error", message: "Cần đăng nhập để đánh giá." });
      return;
    }

    setReviewStatus({ type: "loading", message: "Đang gửi đánh giá..." });

    try {
      const response = await fetch(`${API_URL}/api/testimonials${editingReviewId ? `/${editingReviewId}` : ""}`, {
        method: editingReviewId ? "PATCH" : "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${account.token}`,
        },
        body: JSON.stringify(reviewForm),
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Không thể gui đánh giá.");
      }

      await refreshSite();
      setShowReviewForm(false);
      setEditingReviewId(null);
      setReviewForm({
        name: account.user?.name || account.user?.username || "",
        role: "",
        quote: "",
      });
      setReviewStatus({ type: "success", message: data.message });
    } catch (error) {
      setReviewStatus({ type: "error", message: error.message });
    }
  };

  const deleteReview = async (testimonial) => {
    if (!window.confirm(`Xoá đánh giá của "${testimonial.name}"?`)) return;

    setReviewStatus({ type: "loading", message: "Đang xoá đánh giá..." });

    try {
      const response = await fetch(`${API_URL}/api/testimonials/${testimonial.id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${account.token}` },
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Không thể xoá đánh giá.");
      }

      await refreshSite();
      setReviewStatus({ type: "success", message: data.message });
    } catch (error) {
      setReviewStatus({ type: "error", message: error.message });
    }
  };

  const createPayment = async () => {
    if (!account?.token) {
      setPaymentStatus({ type: "error", message: "Cần đăng nhập trước khi mua gói." });
      return;
    }

    const normalizedCustomAmount = Math.round(Number(customAmount));
    if (selectedPlan === "Custom" && (!Number.isFinite(normalizedCustomAmount) || normalizedCustomAmount < 10000)) {
      setPaymentStatus({ type: "error", message: "Số tiền tùy chọn tối thiểu là 10.000đ." });
      return;
    }

    setPaymentStatus({ type: "loading", message: "Đang tạo mã QR SePay..." });

    try {
      const response = await fetch(`${API_URL}/api/payments/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${account.token}`,
        },
        body: JSON.stringify({
          plan: selectedPlan,
          amount: selectedPlan === "Custom" ? normalizedCustomAmount : undefined,
        }),
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Không thể tạo thanh toán.");
      }

      setCurrentPayment(data.payment);
      setPaymentStatus({
        type: "success",
        message: "Đã tạo QR SePay. Vui lòng chuyển khoản đúng số tiền và nội dung để kích hoạt gói tự động.",
      });
    } catch (error) {
      setPaymentStatus({ type: "error", message: error.message });
    }
  };

  const handleProfileChange = (event) => {
    const { name, value } = event.target;
    setProfileForm((current) => ({ ...current, [name]: value }));
  };

  const submitProfile = async (event) => {
    event.preventDefault();

    if (!account?.token) {
      setProfileStatus({ type: "error", message: "Cần đăng nhập để cập nhật hồ sơ." });
      return;
    }

    setProfileStatus({ type: "loading", message: "Đang cập nhật hồ sơ..." });

    try {
      const response = await fetch(`${API_URL}/api/account/profile`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${account.token}`,
        },
        body: JSON.stringify(profileForm),
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Không thể cập nhật hồ sơ.");
      }

      const nextAccount = { token: account.token, user: data.user };
      localStorage.setItem("ktoolAccount", JSON.stringify(nextAccount));
      setAccount(nextAccount);
      setProfileStatus({ type: "success", message: data.message });
    } catch (error) {
      setProfileStatus({ type: "error", message: error.message });
    }
  };

  const renewSubscription = (plan) => {
    const nextPlan = paymentPlanKeys.includes(plan) ? plan : "Monthly";
    setSelectedPlan(nextPlan);
    setAccountTab("tracking");
    setPaymentStatus({
      type: "success",
      message: `Đã chọn ${planLabels[nextPlan]}. Bấm tạo QR để gia hạn.`,
    });
    window.location.hash = "payment";
  };

  useEffect(() => {
    if (!currentPayment?.orderCode || currentPayment.status !== "pending") return undefined;

    const timer = window.setInterval(async () => {
      try {
        const response = await fetch(`${API_URL}/api/payments/${currentPayment.orderCode}`);
        const data = await response.json();
        if (!response.ok || !data.payment) return;

        setCurrentPayment(data.payment);

        if (data.payment.status === "paid") {
          setPaymentStatus({ type: "success", message: "Thanh toán thành công. Gói đã được kích hoạt." });
          loadSubscriptions();
          if (account?.token) {
            const meResponse = await fetch(`${API_URL}/api/auth/me`, {
              headers: { Authorization: `Bearer ${account.token}` },
            });
            const meData = await meResponse.json();
            if (meResponse.ok) {
              const refreshedAccount = { token: account.token, user: meData.user };
              localStorage.setItem("ktoolAccount", JSON.stringify(refreshedAccount));
              setAccount(refreshedAccount);
            }
          }
        } else if (["amount_mismatch", "failed"].includes(data.payment.status)) {
          setPaymentStatus({ type: "error", message: "Giao dịch đã ghi nhận nhưng chưa khớp số tiền gói." });
        }
      } catch (error) {
        setPaymentStatus({ type: "warning", message: "Đang chờ SePay xác nhận giao dịch." });
      }
    }, 3000);

    return () => window.clearInterval(timer);
  }, [account?.token, currentPayment?.orderCode, currentPayment?.status, loadSubscriptions]);

  const highlightedPlan = site.pricing.find((plan) => plan.highlighted) || site.pricing[0];

  const handleLeadChange = (event) => {
    const { name, value } = event.target;
    setLead((current) => ({ ...current, [name]: value }));
  };

  const submitLead = async (event) => {
    event.preventDefault();
    setStatus({ type: "loading", message: "Đang gửi yêu cầu..." });

    try {
      const response = await fetch(`${API_URL}/api/leads`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(lead),
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Không thể gui yêu cầu.");
      }

      setLead({ name: "", email: "", phone: "", need: "" });
      setStatus({ type: "success", message: data.message });
    } catch (error) {
      setStatus({ type: "error", message: error.message });
    }
  };

  const handleAuthChange = (event) => {
    const { name, value } = event.target;
    setAuthForm((current) => ({ ...current, [name]: value }));
  };

  const submitAuth = async (event) => {
    event.preventDefault();
    setAuthStatus({ type: "loading", message: "Đang xử lý tài khoản..." });

    try {
      const response = await fetch(`${API_URL}/api/auth/${authMode === "register" ? "register" : "login"}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(authForm),
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Không thể xu ly tài khoản.");
      }

      const nextAccount = { token: data.token, user: data.user };
      localStorage.setItem("ktoolAccount", JSON.stringify(nextAccount));
      setAccount(nextAccount);
      setAuthForm({ name: "", email: "", password: "" });
      setAuthStatus({ type: "success", message: data.message });
    } catch (error) {
      setAuthStatus({ type: "error", message: error.message });
    }
  };

  const logoutAccount = async () => {
    if (account?.token) {
      await fetch(`${API_URL}/api/auth/logout`, {
        method: "POST",
        headers: { Authorization: `Bearer ${account.token}` },
      }).catch(() => undefined);
    }

    localStorage.removeItem("ktoolAccount");
    setAccount(null);
    setAuthStatus({ type: "idle", message: "" });
  };

  const revokeMyDevice = async () => {
    if (!account?.token) {
      setDeviceStatus({ type: "warning", message: "Cần đăng nhập để thu hồi thiết bị." });
      return;
    }

    if (!window.confirm("Thu hồi thiết bị đang kích hoạt? Sau đó máy cũ sẽ không dùng addin được nữa.")) return;

    setDeviceStatus({ type: "loading", message: "Đang thu hồi thiết bị..." });

    try {
      const response = await fetch(`${API_URL}/api/account/devices/revoke`, {
        method: "POST",
        headers: { Authorization: `Bearer ${account.token}` },
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Không thể thu hồi thiết bị.");
      }

      await loadMyDevices();
      setDeviceStatus({ type: "success", message: data.message });
    } catch (error) {
      setDeviceStatus({ type: "error", message: error.message });
    }
  };

  const isAdmin = Boolean(account?.user?.isAdmin);
  const filteredAdminUsers = adminUsers.filter((user) => {
    const nameMatch = (user.name || "").toLowerCase().includes(adminFilters.name.trim().toLowerCase());
    const emailMatch = (user.email || "").toLowerCase().includes(adminFilters.email.trim().toLowerCase());
    return nameMatch && emailMatch;
  });
  const adminLeadStatuses = [
    { value: "new", label: "Mới" },
    { value: "contacted", label: "Đã liên hệ" },
    { value: "done", label: "Hoàn tất" },
    { value: "archived", label: "Lưu trữ" },
  ];
  const filteredAdminLeads = adminLeads.filter((leadItem) => {
    const keyword = adminLeadFilters.search.trim().toLowerCase();
    const statusMatch = !adminLeadFilters.status || leadItem.status === adminLeadFilters.status;
    const content = [leadItem.name, leadItem.email, leadItem.phone, leadItem.need]
      .join(" ")
      .toLowerCase();

    return statusMatch && (!keyword || content.includes(keyword));
  });

  const SiteHeader = ({ home = false }) => (
    <header className="topbar">
      <a className="brand" href={home ? "#top" : "/"} aria-label="KTool home">
        <img className="brand-logo" src="/LogoKTool3D.jpg" alt="KTool logo" />
        <span>
          <strong>KTool Addin</strong>
          <small>Design & Drafting</small>
        </span>
      </a>
      <nav className="nav-links" aria-label="Điều hướng chính">
        <a href={home ? "#services" : "/#services"}>Dịch vụ</a>
        <a href={home ? "#pricing" : "/#pricing"}>Bảng giá</a>
        <a href="/Posts">Bài viết</a>
        <a href={home ? "#contact" : "/#contact"}>Liên hệ</a>
        {account?.user && <a href="/my-devices">Thiết bị của tôi</a>}
        {isAdmin && <a href="/Admin/Users">Admin</a>}
        {isAdmin && <a href="/Admin/Posts">Quản lý bài viết</a>}
        {isAdmin && <a href="/Admin/Leads">Yêu cầu</a>}
      </nav>
      <div className="nav-actions">
        <a className="account-link" href="/Account">
          {account?.user?.name || "Tài khoản"}
        </a>
        <a className="nav-cta" href="/KTool">
          Cài đặt ngay
        </a>
      </div>
    </header>
  );

  const rawPath = window.location.pathname.replace(/\/$/, "") || "/";
  const normalizedPath = rawPath === "/Autodesk" ? "/" : rawPath;
  const currentRoute = routeDetails[normalizedPath];
  const posts = site.posts || [];
  const homePosts = posts.slice(0, POSTS_PER_PAGE);
  const pageFromUrl = Number(new URLSearchParams(window.location.search).get("page")) || 1;
  const totalPostPages = Math.max(1, Math.ceil(posts.length / POSTS_PER_PAGE));
  const currentPostPage = Math.min(Math.max(pageFromUrl, 1), totalPostPages);
  const visiblePosts = posts.slice(
    (currentPostPage - 1) * POSTS_PER_PAGE,
    currentPostPage * POSTS_PER_PAGE
  );
  const currentAutodeskProduct =
    autodeskProducts.find((product) => product.key === autodeskSelection.product) ||
    autodeskProducts[0];
  const currentAutodeskMeta = autodeskProductMeta[currentAutodeskProduct?.key] || {
    letter: currentAutodeskProduct?.name?.charAt(0) || "A",
    label: "APP",
    color: "#0f766e",
  };
  const currentAutodeskYear =
    currentAutodeskProduct?.years.find((yearItem) => yearItem.year === autodeskSelection.year) ||
    currentAutodeskProduct?.years[0];
  const currentAutodeskPart =
    currentAutodeskYear?.parts.find((partItem) => partItem.part === autodeskSelection.part) ||
    currentAutodeskYear?.parts[0];
  const isAutodeskRoute = normalizedPath === "/Autodesk";
  const isAdminUsersRoute = normalizedPath === "/Admin/Users";
  const isAdminPostsRoute = normalizedPath === "/Admin/Posts";
  const isAdminLeadsRoute = normalizedPath === "/Admin/Leads";
  const isAccountRoute = normalizedPath === "/Account";
  const isMyDevicesRoute = normalizedPath.toLowerCase() === "/my-devices";
  const isPaymentResultRoute = normalizedPath === "/Payment/Success" || normalizedPath === "/Payment/Cancel";
  const isPostsRoute = normalizedPath === "/Posts";
  const isPostDetailRoute = normalizedPath.startsWith("/Posts/");
  const activePostSlug = isPostDetailRoute ? normalizedPath.replace("/Posts/", "") : "";
  const activePost = posts.find((post) => createPostSlug(post.title) === activePostSlug);

  const installAutodeskPart = () => {
    if (!account?.user) {
      setAutodeskStatus({ type: "warning", message: "Cần đăng nhập để tải phần mềm Autodesk." });
      return;
    }

    if (currentAutodeskPart?.link) {
      window.open(currentAutodeskPart.link, "_blank", "noopener,noreferrer");
      return;
    }

    setAutodeskStatus({ type: "warning", message: "Chờ cập nhật" });
  };

  const openKtoolVideo = (title, videoUrl) => {
    if (!videoUrl) {
      window.alert("Video đang chờ gắn link YouTube.");
      return;
    }

    setActiveVideo({ title, src: normalizeVideoUrl(videoUrl) });
  };

  const renderKtoolImage = (image, className = "") => (
    <button
      aria-label={`Phóng to ${image.alt}`}
      className={`ktool-image-button ${className}`}
      key={image.src}
      onClick={() => setActiveImage(image)}
      type="button"
    >
      <img
        alt={image.alt}
        onError={(event) => {
          event.currentTarget.style.display = "none";
          event.currentTarget.parentElement?.classList.add("is-missing");
        }}
        src={image.src}
      />
      <span>{image.alt}</span>
    </button>
  );

  const imageLightbox = activeImage && (
    <div
      className="image-lightbox"
      onClick={() => setActiveImage(null)}
      role="presentation"
    >
      <button
        aria-label="Đóng ảnh"
        className="lightbox-close"
        onClick={() => setActiveImage(null)}
        type="button"
      >
        X
      </button>
      <img
        alt={activeImage.alt}
        onClick={(event) => event.stopPropagation()}
        src={activeImage.src}
      />
    </div>
  );

  const videoLightbox = activeVideo && (
    <div
      className="video-lightbox"
      onClick={() => setActiveVideo(null)}
      role="presentation"
    >
      <button
        aria-label="Đóng video"
        className="lightbox-close"
        onClick={() => setActiveVideo(null)}
        type="button"
      >
        X
      </button>
      <div className="video-frame" onClick={(event) => event.stopPropagation()}>
        <iframe
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          src={activeVideo.src}
          title={activeVideo.title}
        />
      </div>
    </div>
  );

  if (isAutodeskRoute) {
    return (
      <main className="site-shell">
        <SiteHeader />

        <section className="autodesk-page">
          <div className="autodesk-heading">
            <p className="eyebrow">Download phần mềm Autodesk</p>
            <h1>Tải bộ cài AutoCAD và Revit</h1>
            <p>
              Dữ liệu link được đọc trực tiếp từ file Autodesk.xlsx. Khi file được bổ sung năm hoặc part mới, trang này sẽ tự cập nhật theo.
            </p>
          </div>

          {autodeskStatus.message && (
            <p className={`form-status ${autodeskStatus.type}`}>{autodeskStatus.message}</p>
          )}

          {autodeskProducts.length ? (
            <div className="autodesk-layout">
              <div className="autodesk-product-tabs" role="tablist" aria-label="Chọn phần mềm Autodesk">
                {autodeskProducts.map((product) => {
                  const meta = autodeskProductMeta[product.key] || {
                    letter: product.name.charAt(0),
                    label: "APP",
                    color: "#0f766e",
                  };

                  return (
                    <button
                      className={product.key === currentAutodeskProduct?.key ? "active" : ""}
                      key={product.key}
                      onClick={() => {
                        setAutodeskStatus({ type: "idle", message: "" });
                        setAutodeskSelection({ product: product.key, year: "", part: "" });
                      }}
                      type="button"
                    >
                      <span className="autodesk-mini-icon" style={{ "--accent": meta.color }}>
                        <strong>{meta.letter}</strong>
                        <small>{meta.label}</small>
                      </span>
                      {product.name}
                    </button>
                  );
                })}
              </div>

              <article className="autodesk-download-card">
                <div className="autodesk-card-title">
                  <span className="autodesk-app-icon" style={{ "--accent": currentAutodeskMeta.color }}>
                    <strong>{currentAutodeskMeta.letter}</strong>
                    <small>{currentAutodeskMeta.label}</small>
                  </span>
                  <h2>{currentAutodeskProduct?.name || "Autodesk"}</h2>
                </div>

                <div className="autodesk-select-row">
                  <label>
                    <span>Năm</span>
                    <select
                      onChange={(event) => {
                        setAutodeskStatus({ type: "idle", message: "" });
                        setAutodeskSelection((selection) => ({
                          ...selection,
                          year: event.target.value,
                          part: "",
                        }));
                      }}
                      value={currentAutodeskYear?.year || ""}
                    >
                      {(currentAutodeskProduct?.years || []).map((yearItem) => (
                        <option key={yearItem.year} value={yearItem.year}>
                          {yearItem.year}
                        </option>
                      ))}
                    </select>
                  </label>

                  <label>
                    <span>Part</span>
                    <select
                      onChange={(event) => {
                        setAutodeskStatus({ type: "idle", message: "" });
                        setAutodeskSelection((selection) => ({
                          ...selection,
                          part: event.target.value,
                        }));
                      }}
                      value={currentAutodeskPart?.part || ""}
                    >
                      {(currentAutodeskYear?.parts || []).map((partItem) => (
                        <option key={partItem.part} value={partItem.part}>
                          {/^\d+$/.test(partItem.part) ? `Part ${partItem.part}` : partItem.part}
                        </option>
                      ))}
                    </select>
                  </label>
                </div>

                <button
                  className="autodesk-install-button"
                  disabled={!canDownloadAutodesk}
                  onClick={installAutodeskPart}
                  title={!canDownloadAutodesk ? "Cần đăng nhập để tải" : "Tải phần mềm"}
                  type="button"
                >
                  Install
                </button>

                {!canDownloadAutodesk && (
                  <p className="autodesk-note">
                    Cần <a href="/Account">đăng nhập</a> để tải phần mềm.
                  </p>
                )}

                {canDownloadAutodesk && !currentAutodeskPart?.available && (
                  <p className="autodesk-note">Chờ cập nhật</p>
                )}
              </article>
            </div>
          ) : (
            <div className="empty-state">Chưa có dữ liệu link download Autodesk.</div>
          )}
        </section>
      </main>
    );
  }

  if (isMyDevicesRoute) {
    const activeDevice = deviceInfo.activeDevice;

    return (
      <main className="site-shell">
        <SiteHeader />

        <section className="admin-page my-devices-page">
          <div className="admin-heading">
            <p className="eyebrow">License</p>
            <h1>Thiết bị của tôi</h1>
            <p>Quản lý máy đang kích hoạt addin. Muốn đổi máy thì thu hồi máy cũ trước, sau đó đăng nhập addin trên máy mới.</p>
          </div>

          {deviceStatus.message && (
            <p className={`form-status ${deviceStatus.type}`}>{deviceStatus.message}</p>
          )}

          {!account?.user ? (
            <div className="admin-card my-devices-card">
              <div className="admin-card-head">
                <h2>Cần đăng nhập</h2>
              </div>
              <div className="my-devices-empty">
                <p>Đăng nhập tài khoản Google trên website để xem và thu hồi thiết bị.</p>
                <a className="primary-button" href="/Account">Đăng nhập</a>
              </div>
            </div>
          ) : (
            <div className="admin-card my-devices-card">
              <div className="admin-card-head">
                <h2>Thiết bị đang kích hoạt</h2>
                <button type="button" onClick={loadMyDevices}>Tải lại</button>
              </div>

              {activeDevice?.machineId ? (
                <div className="device-detail">
                  <div>
                    <span>Tên máy</span>
                    <strong>{activeDevice.machineName || "Thiết bị không rõ"}</strong>
                  </div>
                  <div>
                    <span>Revit / Addin</span>
                    <strong>{activeDevice.revitVersion || "Revit"} / {activeDevice.addinVersion || "Addin"}</strong>
                  </div>
                  <div>
                    <span>Kich hoat</span>
                    <strong>{activeDevice.activatedAt ? new Date(activeDevice.activatedAt).toLocaleString("vi-VN") : "-"}</strong>
                  </div>
                  <div>
                    <span>Lan cuoi</span>
                    <strong>{activeDevice.lastSeenAt ? new Date(activeDevice.lastSeenAt).toLocaleString("vi-VN") : "-"}</strong>
                  </div>
                  <button className="danger-button" type="button" onClick={revokeMyDevice}>
                    Revoke thiết bị này
                  </button>
                </div>
              ) : (
                <div className="my-devices-empty">
                  <p>Chưa có máy nào đang kích hoạt. Hãy mở Revit và đăng nhập addin trên máy cần dùng.</p>
                </div>
              )}
            </div>
          )}
        </section>
      </main>
    );
  }

  if (isAdminLeadsRoute) {
    return (
      <main className="site-shell">
        <SiteHeader />

        <section className="admin-page">
          <div className="admin-heading">
            <p className="eyebrow">Admin</p>
            <h1>Quản lý yêu cầu tư vấn</h1>
            <p>Xem và xử lý các yêu cầu được gửi từ form liên hệ trên website.</p>
            <div className="admin-nav">
              <a href="/Admin/Users">Quản lý user</a>
              <a href="/Admin/Posts">Quản lý bài viết</a>
              <a href="/Admin/Leads">Yêu cầu tư vấn</a>
            </div>
          </div>

          {adminLeadStatus.message && (
            <p className={`form-status ${adminLeadStatus.type}`}>{adminLeadStatus.message}</p>
          )}

          <div className="admin-card admin-leads-card">
            <div className="admin-card-head">
              <h2>Danh sách yêu cầu</h2>
              <span>{filteredAdminLeads.length}/{adminLeads.length} yêu cầu</span>
            </div>

            <div className="admin-filters">
              <label>
                Tìm theo tên, Gmail, số điện thoại hoặc nhu cầu
                <input
                  onChange={(event) =>
                    setAdminLeadFilters((current) => ({ ...current, search: event.target.value }))
                  }
                  placeholder="Nhập từ khoá..."
                  value={adminLeadFilters.search}
                />
              </label>
              <label>
                Lọc theo trạng thái
                <select
                  onChange={(event) =>
                    setAdminLeadFilters((current) => ({ ...current, status: event.target.value }))
                  }
                  value={adminLeadFilters.status}
                >
                  <option value="">Tất cả trạng thái</option>
                  {adminLeadStatuses.map((statusItem) => (
                    <option key={statusItem.value} value={statusItem.value}>
                      {statusItem.label}
                    </option>
                  ))}
                </select>
              </label>
            </div>

            <div className="admin-table-wrap">
              <table className="admin-table admin-leads-table">
                <thead>
                  <tr>
                    <th>Người gửi</th>
                    <th>Liên hệ</th>
                    <th>Nhu cầu</th>
                    <th>Ngày gửi</th>
                    <th>Trạng thái</th>
                    <th>Thao tác</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredAdminLeads.length ? (
                    filteredAdminLeads.map((leadItem) => (
                      <tr key={leadItem.id}>
                        <td>
                          <strong>{leadItem.name || "-"}</strong>
                        </td>
                        <td>
                          <div className="admin-lead-contact">
                            <a href={`mailto:${leadItem.email}`}>{leadItem.email}</a>
                            {leadItem.phone ? <a href={`tel:${leadItem.phone}`}>{leadItem.phone}</a> : <span>-</span>}
                          </div>
                        </td>
                        <td>
                          <p className="admin-lead-need">{leadItem.need || "-"}</p>
                        </td>
                        <td>
                          {leadItem.createdAt
                            ? new Date(leadItem.createdAt).toLocaleString("vi-VN")
                            : "-"}
                        </td>
                        <td>
                          <select
                            onChange={(event) => updateAdminLead(leadItem.id, event.target.value)}
                            value={leadItem.status || "new"}
                          >
                            {adminLeadStatuses.map((statusItem) => (
                              <option key={statusItem.value} value={statusItem.value}>
                                {statusItem.label}
                              </option>
                            ))}
                          </select>
                        </td>
                        <td>
                          <div className="admin-actions">
                            <button
                              type="button"
                              onClick={() =>
                                window.open(`mailto:${leadItem.email}`, "_blank", "noopener,noreferrer")
                              }
                            >
                              Email
                            </button>
                            <button className="danger" type="button" onClick={() => deleteAdminLead(leadItem)}>
                              Xoá
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6">
                        <p className="empty-state">Chưa có yêu cầu tư vấn nào.</p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </main>
    );
  }

  if (isAdminPostsRoute) {
    return (
      <main className="site-shell">
        <SiteHeader />

        <section className="admin-page">
          <div className="admin-heading">
            <p className="eyebrow">Admin</p>
            <h1>Quản lý bài viết</h1>
            <p>Tạo, sửa và xoá bài viết hiển thị trên trang Posts.</p>
            <div className="admin-nav">
              <a href="/Admin/Users">Quản lý user</a>
              <a href="/Admin/Posts">Quản lý bài viết</a>
              <a href="/Admin/Leads">Yêu cầu tư vấn</a>
            </div>
          </div>

          {adminPostStatus.message && (
            <p className={`form-status ${adminPostStatus.type}`}>{adminPostStatus.message}</p>
          )}

          <div className="admin-post-layout">
            <form className="admin-post-form" onSubmit={submitAdminPost}>
              <div className="admin-card-head">
                <h2>{editingPostId ? "Sửa bài viết" : "Tạo bài viết mới"}</h2>
                {editingPostId && <span>Đang sửa</span>}
              </div>
              <label>
                Tieu de
                <input name="title" onChange={handleAdminPostChange} value={adminPostForm.title} />
              </label>
              <div className="admin-post-row">
                <label>
                  Nhom
                  <input name="tag" onChange={handleAdminPostChange} value={adminPostForm.tag} />
                </label>
                <label>
                  Ngày đăng
                  <input name="date" onChange={handleAdminPostChange} type="date" value={adminPostForm.date} />
                </label>
              </div>
              <label>
                Tom tat
                <textarea name="excerpt" onChange={handleAdminPostChange} rows="3" value={adminPostForm.excerpt} />
              </label>
              <div className="admin-field">
                <span className="admin-label">Nội dung bài viết</span>
                <div className="rich-editor">
                  <div className="rich-toolbar ribbon-toolbar word-ribbon" aria-label="Công cụ định dạng bài viết">
                    <div className="ribbon-group">
                      <div className="ribbon-row">
                        <select
                          className="font-select"
                          defaultValue="Inter"
                          onChange={(event) => runPostEditorCommand("fontName", event.target.value)}
                        >
                          <option value="Inter">Inter (Body)</option>
                          <option value="Arial">Arial (Body)</option>
                          <option value="Times New Roman">Times New Roman</option>
                          <option value="Georgia">Georgia</option>
                          <option value="Courier New">Courier New</option>
                        </select>
                        <select
                          className="size-select"
                          defaultValue="3"
                          onChange={(event) => runPostEditorCommand("fontSize", event.target.value)}
                        >
                          <option value="2">14</option>
                          <option value="3">16</option>
                          <option value="4">18</option>
                          <option value="5">24</option>
                          <option value="6">32</option>
                        </select>
                        <button className="icon-button" type="button" onClick={() => runPostEditorCommand("fontSize", "5")}>A+</button>
                        <button className="icon-button" type="button" onClick={() => runPostEditorCommand("fontSize", "2")}>A-</button>
                        <button className="icon-button" type="button" onClick={() => runPostEditorCommand("removeFormat")}>A⌫</button>
                      </div>
                      <div className="ribbon-row">
                        <button className="icon-button" type="button" onClick={() => runPostEditorCommand("bold")}>B</button>
                        <button className="icon-button italic" type="button" onClick={() => runPostEditorCommand("italic")}>I</button>
                        <button className="icon-button underline" type="button" onClick={() => runPostEditorCommand("underline")}>U</button>
                        <button className="icon-button strike" type="button" onClick={() => runPostEditorCommand("strikeThrough")}>S</button>
                        <button className="icon-button" type="button" onClick={() => runPostEditorCommand("formatBlock", "h2")}>H2</button>
                        <button className="icon-button" type="button" onClick={() => runPostEditorCommand("formatBlock", "p")}>P</button>
                        <button className="icon-button marker" type="button" onClick={() => runPostEditorCommand("backColor", "#fff36d")}>▰</button>
                        <input
                          aria-label="Màu chữ"
                          defaultValue="#0f766e"
                          onChange={(event) => runPostEditorCommand("foreColor", event.target.value)}
                          type="color"
                        />
                      </div>
                      <span className="ribbon-label">Kiểu chữ</span>
                    </div>

                    <div className="ribbon-group">
                      <div className="ribbon-row">
                        <button className="icon-button wide" type="button" onClick={() => runPostEditorCommand("insertUnorderedList")}>☷</button>
                        <button className="icon-button wide" type="button" onClick={() => runPostEditorCommand("insertOrderedList")}>1≡</button>
                        <button className="icon-button" type="button" onClick={() => runPostEditorCommand("outdent")}>←</button>
                        <button className="icon-button" type="button" onClick={() => runPostEditorCommand("indent")}>→</button>
                        <button className="icon-button" type="button" onClick={() => runPostEditorCommand("insertHorizontalRule")}>─</button>
                      </div>
                      <div className="ribbon-row">
                        <button className="icon-button align-left" type="button" onClick={() => runPostEditorCommand("justifyLeft")}>≡</button>
                        <button className="icon-button align-center" type="button" onClick={() => runPostEditorCommand("justifyCenter")}>≡</button>
                        <button className="icon-button align-right" type="button" onClick={() => runPostEditorCommand("justifyRight")}>≡</button>
                        <button className="icon-button" type="button" onClick={() => runPostEditorCommand("justifyĐầy đủ")}>▤</button>
                        <button className="icon-button wide" type="button" onClick={() => runPostEditorCommand("formatBlock", "blockquote")}>Trích dẫn</button>
                      </div>
                      <span className="ribbon-label">Đoạn văn</span>
                    </div>

                    <div className="ribbon-group">
                      <div className="ribbon-row">
                        <button
                          className="icon-button wide"
                          type="button"
                          onClick={() => {
                            const url = window.prompt("Nhập liên kết cần chèn");
                            if (url) runPostEditorCommand("createLiên kết", url);
                          }}
                        >
                          Liên kết
                        </button>
                        <button
                          className="icon-button wide"
                          type="button"
                          onClick={() => {
                            const url = window.prompt("Nhập URL ảnh");
                            insertPostImage(url);
                          }}
                        >
                          Ảnh URL
                        </button>
                        <button className="icon-button wide" type="button" onClick={() => postImageInputRef.current?.click()}>
                          Tải ảnh
                        </button>
                        <button
                          className="icon-button wide"
                          type="button"
                          onClick={() => {
                            const url = window.prompt("Nhập link video YouTube/Vimeo/MP4");
                            insertPostVideo(url);
                          }}
                        >
                          Video
                        </button>
                      </div>
                      <div className="ribbon-row">
                        <button className="icon-button wide" type="button" onClick={() => applySelectedImageLayout("left")}>Ảnh trái</button>
                        <button className="icon-button wide" type="button" onClick={() => applySelectedImageLayout("center")}>Ảnh giữa</button>
                        <button className="icon-button wide" type="button" onClick={() => applySelectedImageLayout("right")}>Ảnh phải</button>
                        <button className="icon-button wide" type="button" onClick={() => applySelectedImageLayout("full")}>Đầy đủ</button>
                        <button className="icon-button wide danger" type="button" onClick={removeSelectedImage}>Xoá</button>
                      </div>
                      <span className="ribbon-label">Chèn / Vẽ</span>
                    </div>

                    <div className="ribbon-group drawing-group">
                      <div className="shape-grid" aria-label="Hình vẽ">
                        <button type="button" onClick={() => insertEditorShape("rect")}>□</button>
                        <button type="button" onClick={() => insertEditorShape("round")}>▢</button>
                        <button type="button" onClick={() => insertEditorShape("circle")}>○</button>
                        <button type="button" onClick={() => insertEditorShape("triangle")}>△</button>
                        <button type="button" onClick={() => insertEditorShape("line")}>╱</button>
                        <button type="button" onClick={() => insertEditorShape("arrow")}>→</button>
                        <button type="button" onClick={() => insertEditorShape("star")}>☆</button>
                        <button type="button" onClick={() => insertEditorShape("rect")}>▭</button>
                      </div>
                      <span className="ribbon-label">Vẽ</span>
                    </div>

                    <div className="ribbon-group compact-group">
                      <div className="ribbon-row stack-row">
                        <button className="icon-button wide" type="button" onClick={() => applySelectedImageLayout("left")}>Xếp trái</button>
                        <button className="icon-button wide" type="button" onClick={() => applySelectedImageLayout("right")}>Xếp phải</button>
                      </div>
                      <div className="ribbon-row stack-row">
                        <input
                          aria-label="Màu nền hình"
                          defaultValue="#e6f4f1"
                          onChange={(event) => applyEditorElementStyle("backgroundColor", event.target.value)}
                          type="color"
                        />
                        <input
                          aria-label="Viền hình"
                          defaultValue="#0f766e"
                          onChange={(event) => applyEditorElementStyle("borderColor", event.target.value)}
                          type="color"
                        />
                        <button className="icon-button wide" type="button" onClick={() => applyEditorElementStyle("boxShadow", "0 12px 30px rgba(21, 32, 43, 0.25)")}>FX</button>
                      </div>
                      <span className="ribbon-label">Kiểu hình</span>
                    </div>
                    <input
                      accept="image/*"
                      hidden
                      onChange={uploadPostImage}
                      ref={postImageInputRef}
                      type="file"
                    />
                  </div>
                  <div
                    className="rich-editor-surface"
                    contentEditable
                    dangerouslySetInnerHTML={{ __html: adminPostForm.content }}
                    key={adminEditorKey}
                    onBlur={syncPostEditorContent}
                    onClick={handleEditorClick}
                    onInput={handlePostEditorInput}
                    ref={postEditorRef}
                    suppressContentEditableWarning
                  />
                </div>
              </div>
              <div className="admin-post-actions">
                <button type="submit">{editingPostId ? "Cập nhật bài viết" : "Đăng bài viết"}</button>
                <button className="secondary" type="button" onClick={resetAdminPostForm}>
                  Làm mới
                </button>
              </div>
            </form>

            <div className="admin-card">
              <div className="admin-card-head">
                <h2>Danh sách bài viết</h2>
                <span>{adminPosts.length} bai</span>
              </div>
              <div className="admin-post-list">
                {adminPosts.length ? (
                  adminPosts.map((post) => (
                    <article className="admin-post-item" key={post.id}>
                      <div>
                        <span>{post.tag}</span>
                        <h3>{post.title}</h3>
                        <p>{post.excerpt}</p>
                        <time dateTime={post.date}>{post.date}</time>
                      </div>
                      <div className="admin-actions">
                        <a href={`/Posts/${createPostSlug(post.title)}`}>Xem</a>
                        <button type="button" onClick={() => startEditAdminPost(post)}>
                          Sửa
                        </button>
                        <button className="danger" type="button" onClick={() => deleteAdminPost(post)}>
                          Xoá
                        </button>
                      </div>
                    </article>
                  ))
                ) : (
                  <p className="empty-state">Chưa có bài viết nào.</p>
                )}
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }

  if (isAdminUsersRoute) {
    return (
      <main className="site-shell">
        <SiteHeader />

        <section className="admin-page">
          <div className="admin-heading">
            <p className="eyebrow">Admin</p>
            <h1>Quản lý tài khoản</h1>
            <p>Xem các tài khoản đã đăng ký hoặc đăng nhập bằng Google trên hệ thống local.</p>
            <div className="admin-nav">
              <a href="/Admin/Users">Quản lý user</a>
              <a href="/Admin/Posts">Quản lý bài viết</a>
              <a href="/Admin/Leads">Yêu cầu tư vấn</a>
            </div>
          </div>

          {adminStatus.message && (
            <p className={`form-status ${adminStatus.type}`}>{adminStatus.message}</p>
          )}

          <div className="admin-card">
            <div className="admin-card-head">
              <h2>Danh sách người dùng</h2>
              <span>{filteredAdminUsers.length}/{adminUsers.length} tài khoản</span>
            </div>

            <div className="admin-filters">
              <label>
                Lọc theo tên
                <input
                  onChange={(event) =>
                    setAdminFilters((current) => ({ ...current, name: event.target.value }))
                  }
                  placeholder="Nhập tên user..."
                  value={adminFilters.name}
                />
              </label>
              <label>
                Lọc theo Gmail
                <input
                  onChange={(event) =>
                    setAdminFilters((current) => ({ ...current, email: event.target.value }))
                  }
                  placeholder="Nhập Gmail..."
                  value={adminFilters.email}
                />
              </label>
            </div>

            <div className="admin-table-wrap">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>Tên</th>
                    <th>Gmail</th>
                    <th>Nguồn</th>
                    <th>Gói</th>
                    <th>Ngày bắt đầu</th>
                    <th>Ngày kết thúc</th>
                    <th>Trạng thái</th>
                    <th>Thiết bị đang kích hoạt</th>
                    <th>Ngày tạo</th>
                    <th>Phiên</th>
                    <th>Kiểm soát</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredAdminUsers.length ? (
                    filteredAdminUsers.map((user) => (
                      <tr key={user.id}>
                        <td>
                          <div className="admin-user">
                            {user.avatar ? (
                              <img src={user.avatar} alt="" />
                            ) : (
                              <span>{(user.name || user.email).slice(0, 1).toUpperCase()}</span>
                            )}
                            <strong>{user.name || "Chưa có tên"}</strong>
                          </div>
                        </td>
                        <td>{user.email}</td>
                        <td>{user.provider === "google" ? "Google" : "Gmail local"}</td>
                        <td>
                          <select
                            defaultValue={user.plan || "Free"}
                            onChange={(event) => updateAdminUser(user.id, { plan: event.target.value })}
                          >
                            <option value="Free">Free</option>
                            <option value="Monthly">Monthly</option>
                            <option value="Yearly">Yearly</option>
                            <option value="Lifetime">Vĩnh viễn</option>
                          </select>
                        </td>
                        <td>
                          <input
                            defaultValue={user.startsAt ? user.startsAt.slice(0, 10) : ""}
                            onBlur={(event) => updateAdminUser(user.id, { startsAt: event.target.value })}
                            type="date"
                          />
                        </td>
                        <td>
                          {user.unlimited || ["Free", "Lifetime"].includes(user.plan) ? (
                            <span className="admin-infinity">Vô hạn</span>
                          ) : (
                            <>
                              <input
                                defaultValue={user.expiresAt ? user.expiresAt.slice(0, 10) : ""}
                                onBlur={(event) => updateAdminUser(user.id, { expiresAt: event.target.value })}
                                type="date"
                              />
                              {user.expired && <small className="admin-warning">Hết hạn</small>}
                            </>
                          )}
                        </td>
                        <td>
                          <select
                            defaultValue={user.status || "active"}
                            onChange={(event) => updateAdminUser(user.id, { status: event.target.value })}
                          >
                            <option value="active">Đang hoạt động</option>
                            <option value="suspended">Khóa</option>
                          </select>
                        </td>
                        <td>
                          {user.activeDevice?.machineId ? (
                            <div className="admin-device">
                              <strong>{user.activeDevice.machineName || "Thiết bị không rõ"}</strong>
                              <span>{user.activeDevice.revitVersion || "Revit"} / {user.activeDevice.addinVersion || "Addin"}</span>
                            </div>
                          ) : (
                            <span className="admin-muted">Chưa có</span>
                          )}
                        </td>
                        <td>{user.createdAt ? new Date(user.createdAt).toLocaleString("vi-VN") : "-"}</td>
                        <td>
                          <strong>{user.sessionCount}</strong>
                          <small className="admin-muted">Addin: {user.addinSessionCount}</small>
                        </td>
                        <td>
                          <div className="admin-actions">
                            <button
                              type="button"
                              onClick={() => runAdminAction(user.id, "revoke-sessions", `Thu hồi tất cả phiên đăng nhập của ${user.email}?`)}
                            >
                              Thu hồi phiên
                            </button>
                            <button
                              type="button"
                              onClick={() => runAdminAction(user.id, "clear-device", `Xoá thiết bị đang kích hoạt của ${user.email}?`)}
                            >
                              Xóa thiết bị
                            </button>
                            <button
                              className="danger"
                              disabled={user.isAdmin}
                              type="button"
                              onClick={() => deleteAdminUser(user.id, user.email)}
                            >
                              Xóa account
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="11">Chưa có tài khoản nào.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </main>
    );
  }

  if (isPaymentResultRoute) {
    const orderCode = new URLSearchParams(window.location.search).get("orderCode");
    const isSuccess = normalizedPath === "/Payment/Success";

    return (
      <main className="site-shell">
        <SiteHeader />
        <section className="payment-result-page">
          <p className="eyebrow">Thanh toán</p>
          <h1>{isSuccess ? "Đang kiểm tra thanh toán" : "Thanh toán đã hủy"}</h1>
          <p>
            {isSuccess
              ? "Nếu ngân hàng đã xác nhận giao dịch, SePay sẽ gửi webhook về server để tự kích hoạt gói."
              : "Bạn có thể quay lại trang tài khoản để tạo mã QR thanh toán mới."}
          </p>
          {orderCode && <span>Mã đơn: {orderCode}</span>}
          <div className="hero-actions">
            <a className="primary-button" href="/Account">
              Về tài khoản
            </a>
            <a className="secondary-button" href="/Admin/Users">
              Xem admin
            </a>
          </div>
        </section>
      </main>
    );
  }

  if (isAccountRoute) {
    return (
      <main className="site-shell">
        <SiteHeader />

        <section className="account-page">
          <div className="account-copy">
            <p className="eyebrow">Tài khoản</p>
            <h1>Đăng ký và đăng nhập bằng Gmail</h1>
            <p>
              Tài khoản giúp người dùng lưu thông tin tư vấn, theo dõi bài viết và chuẩn bị cho các tính năng license sau này.
            </p>
          </div>

          <div className="account-panel">
            {account?.user ? (
              <div className={`account-profile ${accountTab}`}>
                <span className="account-avatar">{account.user.name.slice(0, 1).toUpperCase()}</span>
                <div>
                  <p className="eyebrow">Đang đăng nhập</p>
                  <h2>{account.user.name}</h2>
                  <p>{account.user.email}</p>
                </div>
                <div className="account-tabs" role="tablist" aria-label="Quản lý tài khoản">
                  <button
                    className={accountTab === "tracking" ? "active" : ""}
                    type="button"
                    onClick={() => setAccountTab("tracking")}
                  >
                    Theo doi
                  </button>
                  <button
                    className={accountTab === "profile" ? "active" : ""}
                    type="button"
                    onClick={() => setAccountTab("profile")}
                  >
                    Chỉnh sửa hồ sơ
                  </button>
                </div>
                <div className="account-license">
                  <p className="eyebrow">Gói hiện tại</p>
                  <strong>{account.user.license?.plan || "Free"}</strong>
                  <span>
                    {account.user.license?.expiresAt
                      ? `Hết hạn: ${new Date(account.user.license.expiresAt).toLocaleDateString("vi-VN")}`
                      : "Vô hạn"}
                  </span>
                </div>
                <form className="profile-edit-form" onSubmit={submitProfile}>
                  <p className="eyebrow">Chỉnh sửa hồ sơ</p>
                  <label>
                    Tên đăng nhập *
                    <input name="username" onChange={handleProfileChange} value={profileForm.username} />
                  </label>
                  <label>
                    E-mail *
                    <input name="email" onChange={handleProfileChange} type="email" value={profileForm.email} />
                  </label>
                  <label>
                    Họ tên
                    <input name="name" onChange={handleProfileChange} value={profileForm.name} />
                  </label>
                  <label>
                    Mật khẩu mới
                    <input
                      name="password"
                      onChange={handleProfileChange}
                      placeholder="Bỏ trống nếu không đổi"
                      type="password"
                      value={profileForm.password}
                    />
                  </label>
                  <label>
                    Lặp lại mật khẩu
                    <input
                      name="passwordConfirm"
                      onChange={handleProfileChange}
                      placeholder="Nhập lại mật khẩu mới"
                      type="password"
                      value={profileForm.passwordConfirm}
                    />
                  </label>
                  <button type="submit">Cập nhật hồ sơ</button>
                  {profileStatus.message && (
                    <p className={`form-status ${profileStatus.type}`}>{profileStatus.message}</p>
                  )}
                </form>

                <div className="subscription-box">
                  <div className="account-section-title">
                    <p className="eyebrow">Thông tin gói</p>
                    <h3>Danh sách gói đã đăng ký</h3>
                  </div>
                  <div className="subscription-table-wrap">
                    <table className="subscription-table">
                      <thead>
                        <tr>
                          <th>Gói</th>
                          <th>Ngày bắt đầu</th>
                          <th>Ngày hết hạn</th>
                          <th>Trạng thái</th>
                          <th>Thao tac</th>
                        </tr>
                      </thead>
                      <tbody>
                        {subscriptions.map((subscription) => (
                          <tr key={`${subscription.id}-${subscription.orderCode || "current"}`}>
                            <td>
                              <strong>{subscription.planName || subscription.plan}</strong>
                              {subscription.amount > 0 && (
                                <small>{Number(subscription.amount).toLocaleString("vi-VN")}d</small>
                              )}
                            </td>
                            <td>{formatDate(subscription.startsAt)}</td>
                            <td>{formatDate(subscription.expiresAt)}</td>
                            <td>
                              <span className={`subscription-status ${subscription.status}`}>
                                {subscriptionStatusLabels[subscription.status] || subscription.status}
                              </span>
                            </td>
                            <td>
                              {subscription.status === "expired" ? (
                                <button type="button" onClick={() => renewSubscription(subscription.plan)}>
                                  Gia han
                                </button>
                              ) : (
                                <span className="account-muted">-</span>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="payment-box" id="payment">
                  <label>
                    Chọn gói đăng ký
                    <select
                      value={selectedPlan}
                      onChange={(event) => {
                        setSelectedPlan(event.target.value);
                        setCurrentPayment(null);
                        setPaymentStatus({
                          type: "success",
                          message: `Đã chọn ${planLabels[event.target.value] || "gói đăng ký"}. Bấm tạo QR để thanh toán.`,
                        });
                      }}
                    >
                      {paymentPlanOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </label>
                  {selectedPlan === "Custom" && (
                    <label className="custom-amount-field">
                      Số tiền tùy chọn
                      <input
                        min="10000"
                        onChange={(event) => setCustomAmount(event.target.value)}
                        placeholder="Nhập số tiền, ví dụ 500000"
                        step="1000"
                        type="number"
                        value={customAmount}
                      />
                    </label>
                  )}
                  <button type="button" onClick={createPayment}>
                    Tạo QR thanh toán SePay
                  </button>
                  {paymentStatus.message && (
                    <p className={`form-status ${paymentStatus.type}`}>{paymentStatus.message}</p>
                  )}
                  {currentPayment && (
                    <div className="sepay-payment-card">
                      <img src={currentPayment.qrUrl} alt="QR thanh toán SePay" />
                      <div>
                        <p className="eyebrow">Thông tin chuyển khoản</p>
                        <dl>
                          <div>
                            <dt>Ngan hang</dt>
                            <dd>{currentPayment.bankCode}</dd>
                          </div>
                          <div>
                            <dt>So tài khoản</dt>
                            <dd>{currentPayment.accountNumber}</dd>
                          </div>
                          {currentPayment.accountName && (
                            <div>
                              <dt>Chủ tài khoản</dt>
                              <dd>{currentPayment.accountName}</dd>
                            </div>
                          )}
                          <div>
                            <dt>So tien</dt>
                            <dd>{Number(currentPayment.amount).toLocaleString("vi-VN")}d</dd>
                          </div>
                          <div>
                            <dt>Nội dung</dt>
                            <dd>{currentPayment.transferContent}</dd>
                          </div>
                        </dl>
                        <span className={`payment-state ${currentPayment.status}`}>
                          {currentPayment.status === "paid" ? "Đã thanh toán" : "Đang chờ xác nhận"}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
                <a className="google-auth-button" href="/my-devices">
                  Thiết bị của tôi
                </a>
                <button className="account-logout-button" type="button" onClick={logoutAccount}>
                  Đăng xuất
                </button>
              </div>
            ) : (
              <>
                <div className="auth-tabs" role="tablist" aria-label="Chọn kiểu tài khoản">
                  <button
                    className={authMode === "login" ? "active" : ""}
                    type="button"
                    onClick={() => {
                      setAuthMode("login");
                      setAuthStatus({ type: "idle", message: "" });
                    }}
                  >
                    Đăng nhập
                  </button>
                  <button
                    className={authMode === "register" ? "active" : ""}
                    type="button"
                    onClick={() => {
                      setAuthMode("register");
                      setAuthStatus({ type: "idle", message: "" });
                    }}
                  >
                    Đăng ký
                  </button>
                </div>

                <a className="google-auth-button" href={`${API_URL}/api/auth/google`}>
                  Đăng nhập bằng Google
                </a>

                <form className="auth-form" onSubmit={submitAuth}>
                  {authMode === "register" && (
                    <label>
                      Họ tên
                      <input
                        name="name"
                        onChange={handleAuthChange}
                        placeholder="Nguyen Van A"
                        type="text"
                        value={authForm.name}
                      />
                    </label>
                  )}
                  <label>
                    Gmail
                    <input
                      name="email"
                      onChange={handleAuthChange}
                      placeholder="tenban@gmail.com"
                      type="email"
                      value={authForm.email}
                    />
                  </label>
                  <label>
                    Mật khẩu
                    <input
                      name="password"
                      onChange={handleAuthChange}
                      placeholder="Tối thiểu 6 ký tự"
                      type="password"
                      value={authForm.password}
                    />
                  </label>
                  <button type="submit">{authMode === "register" ? "Tạo tài khoản" : "Đăng nhập"}</button>
                </form>

                {authStatus.message && (
                  <p className={`form-status ${authStatus.type}`}>{authStatus.message}</p>
                )}
              </>
            )}
          </div>
        </section>
      </main>
    );
  }

  if (isPostsRoute) {
    return (
      <main className="site-shell">
        <header className="topbar">
          <a className="brand" href="/" aria-label="KTool home">
            <img className="brand-logo" src="/LogoKTool3D.jpg" alt="KTool logo" />
            <span>
              <strong>KTool Addin</strong>
              <small>Design & Drafting</small>
            </span>
          </a>
          <nav className="nav-links" aria-label="Điều hướng chính">
            <a href="/#services">Dịch vụ</a>
            <a href="/#pricing">Bảng giá</a>
            <a href="/Posts">Bài viết</a>
            <a href="/#contact">Liên hệ</a>
            <a href="/Account">{account?.user?.name || "Tài khoản"}</a>
            {isAdmin && <a href="/Admin/Users">Admin</a>}
          </nav>
          <a className="nav-cta" href="/KTool">
            Cài đặt ngay
          </a>
        </header>

        <section className="posts-page">
          <div className="posts-page-heading">
            <p className="eyebrow">Thực tế vẫn là thực tế, sống ai mà chẳng có đam mê. Đam mê là một chuyện, sống được với nó là chuyện khác. Đam mê không kiếm ra tiền thì trước sau gì cũng bị thời gian nghiền nát. </p>
          </div>
          <div className="post-list posts-page-list">
            {visiblePosts.map((post) => (
              <a className="post-link-card" href={`/Posts/${createPostSlug(post.title)}`} key={post.title}>
                <span>{post.tag}</span>
                <h3>{post.title}</h3>
                <p>{post.excerpt}</p>
                <time dateTime={post.date}>{post.date}</time>
              </a>
            ))}
          </div>
          {totalPostPages > 1 && (
            <nav className="pagination" aria-label="Phân trang bài viết">
              {Array.from({ length: totalPostPages }, (_, index) => index + 1).map((page) => (
                <a
                  className={page === currentPostPage ? "active" : ""}
                  href={`/Posts?page=${page}`}
                  key={page}
                >
                  {page}
                </a>
              ))}
            </nav>
          )}
        </section>
      </main>
    );
  }

  if (isPostDetailRoute) {
    return (
      <main className="site-shell">
        <header className="topbar">
          <a className="brand" href="/" aria-label="KTool home">
            <img className="brand-logo" src="/LogoKTool3D.jpg" alt="KTool logo" />
            <span>
              <strong>KTool Addin</strong>
              <small>Design & Drafting</small>
            </span>
          </a>
          <nav className="nav-links" aria-label="Điều hướng chính">
            <a href="/#services">Dịch vụ</a>
            <a href="/#pricing">Bảng giá</a>
            <a href="/Posts">Bài viết</a>
            <a href="/#contact">Liên hệ</a>
            <a href="/Account">{account?.user?.name || "Tài khoản"}</a>
            {isAdmin && <a href="/Admin/Users">Admin</a>}
          </nav>
          <a className="nav-cta" href="/KTool">
            Cài đặt ngay
          </a>
        </header>

        <article className="post-detail-page">
          {activePost ? (
            <>
              <p className="eyebrow">{activePost.tag}</p>
              <h1>{activePost.title}</h1>
              <time dateTime={activePost.date}>{activePost.date}</time>
              <p>{activePost.excerpt}</p>
              {activePost.content && (
                hasHtmlContent(activePost.content) ? (
                  <div
                    className="post-detail-content"
                    dangerouslySetInnerHTML={{ __html: activePost.content }}
                  />
                ) : (
                  <div className="post-detail-content">
                    {activePost.content.split(/\n+/).map((paragraph) => (
                      <p key={paragraph}>{paragraph}</p>
                    ))}
                  </div>
                )
              )}
              <section className="post-comments">
                <div className="comments-head">
                  <div>
                    <p className="eyebrow">Bình luận</p>
                    <h2>{activePost.comments?.length || 0} bình luận</h2>
                  </div>
                  {!account?.user && (
                    <a className="secondary-button" href="/Account">
                      Đăng nhập để bình luận
                    </a>
                  )}
                </div>

                {account?.user && (
                  <form className="comment-form" onSubmit={submitPostComment}>
                    <label>
                      Nội dung bình luận
                      <textarea
                        onChange={(event) => setCommentText(event.target.value)}
                        placeholder="Chia sẻ câu hỏi hoặc ý kiến của bạn..."
                        rows="4"
                        value={commentText}
                      />
                    </label>
                    <button type="submit">Gửi bình luận</button>
                  </form>
                )}

                {commentStatus.message && (
                  <p className={`form-status ${commentStatus.type}`}>{commentStatus.message}</p>
                )}

                <div className="comment-list">
                  {(activePost.comments || []).map((comment) => (
                    <article className="comment-item" key={comment.id}>
                      <div>
                        <strong>{comment.name}</strong>
                        <time dateTime={comment.createdAt}>{comment.createdAt?.slice(0, 10)}</time>
                      </div>
                      <p>{comment.content}</p>
                      {isAdmin && (
                        <button
                          className="text-danger-button"
                          type="button"
                          onClick={() => deletePostComment(activePost.id, comment.id)}
                        >
                          Xoá bình luận
                        </button>
                      )}
                      <div className="reply-list">
                        {(comment.replies || []).map((reply) => (
                          <article className="reply-item" key={reply.id}>
                            <div>
                              <strong>{reply.name}</strong>
                              <time dateTime={reply.createdAt}>{reply.createdAt?.slice(0, 10)}</time>
                            </div>
                            <p>{reply.content}</p>
                            {isAdmin && (
                              <button
                                className="text-danger-button"
                                type="button"
                                onClick={() => deleteCommentReply(activePost.id, comment.id, reply.id)}
                              >
                                Xoá trả lời
                              </button>
                            )}
                          </article>
                        ))}
                      </div>
                      {account?.user && (
                        <form className="reply-form" onSubmit={(event) => submitCommentReply(event, comment.id)}>
                          <input
                            onChange={(event) =>
                              setReplyTexts((current) => ({ ...current, [comment.id]: event.target.value }))
                            }
                            placeholder="Trả lời bình luận này..."
                            value={replyTexts[comment.id] || ""}
                          />
                          <button type="submit">Trả lời</button>
                        </form>
                      )}
                    </article>
                  ))}
                  {!activePost.comments?.length && (
                    <p className="empty-note">Chưa có bình luận nào cho bài viết này.</p>
                  )}
                </div>
              </section>
              <div className="hero-actions">
                <a className="secondary-button" href="/Posts">
                  Quay lại bài viết
                </a>
              </div>
            </>
          ) : (
            <>
              <p className="eyebrow">Bài viết</p>
              <h1>Không tìm thấy bài viết</h1>
              <p>Bài viết có thể chưa tồn tại hoặc đường dẫn đã thay đổi.</p>
              <div className="hero-actions">
                <a className="secondary-button" href="/Posts">
                  Xem danh sách bài viết
                </a>
              </div>
            </>
          )}
        </article>
      </main>
    );
  }

  if (currentRoute) {
    if (normalizedPath === "/KTool") {
      return (
        <main className="site-shell">
          <SiteHeader />

          <section className="ktool-detail-page">
            <div className="ktool-ribbon-panel">
              {renderKtoolImage({ src: "/PreviewRibbon.png", alt: "KTool Ribbon" }, "ktool-ribbon-image")}
            </div>

            <section className="ktool-install-section">
              <div>
                <p className="eyebrow">KTool Addin</p>
                <h1>Video hướng dẫn cài đặt</h1>
                <p>
                  KTool Addin đã hỗ trợ cho phiên bản Revit 2020, 2021, 2022, 2023, 2024, 2025, 2026.
                  Vui lòng xem video hướng dẫn bên dưới để quá trình cài đặt và đăng ký trở nên đơn giản hơn.
                </p>
              </div>
              <button
                className="ktool-video-card"
                onClick={() =>
                  openKtoolVideo(
                    "Video hướng dẫn cài đặt",
                    ktoolInstallVideoUrl
                  )
                }
                type="button"
              >
                <img className="ktool-video-thumb" src={ktoolInstallVideoThumb} alt="Video hÆ°á»›ng dáº«n cÃ i Ä‘áº·t" />
                <span className="play-mark" aria-hidden="true" />
                <small>Video hướng dẫn cài đặt.</small>
              </button>
              <div className="ktool-install-actions">
                <a className="primary-button" href={ktoolInstaller.downloadUrl}>
                  Tải về ngay
                </a>
                <a className="ktool-zalo-button" href={ktoolZaloGroupUrl} rel="noreferrer" target="_blank">
                  <img alt="" src="/icons8-zalo-100.png" />
                  <span>Nhóm Zalo hỗ trợ</span>
                </a>
                <span className="ktool-installer-version">{ktoolInstaller.fileName}</span>
              </div>
            </section>

            <section className="ktool-feature-section">
              <div className="section-heading">
                <p className="eyebrow">Tính năng</p>
                <h2>Một số chức năng điển hình</h2>
              </div>

              {ktoolFeatureGroups.map((group) => (
                <article className="ktool-feature-band" key={group.title}>
                  <div className="ktool-feature-copy">
                    <h3>{group.title}</h3>
                    <p>{group.description}</p>
                    <button
                      className="ktool-play-button"
                      onClick={() => openKtoolVideo(group.title, group.videoUrl)}
                      type="button"
                    >
                      <span className="play-mark" aria-hidden="true" />
                      <span>Xem video</span>
                    </button>
                  </div>
                  <div
                    className={
                      group.images.length > 4
                        ? "ktool-image-strip compact"
                        : group.images.length === 1
                          ? "ktool-image-strip single"
                          : "ktool-image-strip"
                    }
                  >
                    {group.images.map((image) => renderKtoolImage(image))}
                  </div>
                </article>
              ))}

              <div className="ktool-final-video">
                <p>Xem chi tiết các tiện ích KTool Addin</p>
                <a
                  className="ktool-play-button large"
                  href="https://www.youtube.com/watch?v=j3ks1rx27zE&list=PLV8jr8yfaWZJMRr-L2hvJhUTewt0Ou9mx"
                  rel="noreferrer"
                  target="_blank"
                >
                  <span className="play-mark" aria-hidden="true" />
                  <span>Xem video tổng quan</span>
                </a>
              </div>
            </section>
          </section>

          {imageLightbox}
          {videoLightbox}
        </main>
      );
    }

    if (normalizedPath === "/API") {
      return (
        <main className="site-shell">
          <header className="topbar">
            <a className="brand" href="/" aria-label="KTool home">
              <img className="brand-logo" src="/LogoKTool3D.jpg" alt="KTool logo" />
              <span>
                <strong>KTool Addin</strong>
                <small>Design & Drafting</small>
              </span>
            </a>
            <nav className="nav-links" aria-label="Điều hướng chính">
              <a href="/#services">Dịch vụ</a>
              <a href="/#pricing">Bảng giá</a>
              <a href="/Posts">Bài viết</a>
              <a href="/#contact">Liên hệ</a>
              <a href="/Account">{account?.user?.name || "Tài khoản"}</a>
              {isAdmin && <a href="/Admin/Users">Admin</a>}
            </nav>
            <a className="nav-cta" href="/KTool">
              Cài đặt ngay
            </a>
          </header>

          <section className="api-hero">
            <div className="api-hero-copy">
              <p className="eyebrow">{currentRoute.eyebrow}</p>
              <h1>{currentRoute.title}</h1>
              <p>{currentRoute.text}</p>
              <div className="hero-actions">
                <a className="primary-button" href="/#contact">
                  Tư vấn workflow
                </a>
                <a className="secondary-button" href="/Learn">
                  Xem đào tạo Revit MEPF
                </a>
              </div>
            </div>
            <button
              aria-label="Phóng to ảnh phát triển Revit Addin"
              className="api-hero-media"
              onClick={() => setActiveImage({ src: "/DevAddin.png", alt: "Phát triển Revit Addin" })}
              type="button"
            >
              <img src="/DevAddin.png" alt="Phát triển Revit Addin theo yêu cầu" />
            </button>
            <div className="api-hero-lightbox">
              {imageLightbox}
            </div>
          </section>

          <section className="api-section">
            <div className="section-heading">
              <p className="eyebrow">Dịch vụ bao gồm</p>
              <h2>Từ phân tích quy trình đến công cụ dùng thật</h2>
            </div>
            <div className="api-service-grid">
              {currentRoute.services.map((item) => (
                <article className="api-card" key={item}>
                  <span>API</span>
                  <h3>{item}</h3>
                </article>
              ))}
            </div>
          </section>

          <section className="api-summary">
            <div>
              <p className="eyebrow">Giá trị mang lại</p>
              <h2>Tự động hóa đúng quy trình của đội ngũ</h2>
              <ul className="check-list">
                {currentRoute.values.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
            <div className="api-side-grid">
              <aside className="support-card">
                <p className="eyebrow">Phù hợp cho</p>
                <ul>
                  {currentRoute.audiences.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </aside>
              <aside className="support-card">
                <p className="eyebrow">Nhận phát triển</p>
                <ul>
                  {currentRoute.deliverables.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </aside>
            </div>
          </section>
        </main>
      );
    }

    if (normalizedPath === "/Drafting") {
      return (
        <main className="site-shell">
          <header className="topbar">
            <a className="brand" href="/" aria-label="KTool home">
              <img className="brand-logo" src="/LogoKTool3D.jpg" alt="KTool logo" />
              <span>
                <strong>KTool Addin</strong>
                <small>Design & Drafting</small>
              </span>
            </a>
            <nav className="nav-links" aria-label="Điều hướng chính">
              <a href="/#services">Dịch vụ</a>
              <a href="/#pricing">Bảng giá</a>
              <a href="/Posts">Bài viết</a>
              <a href="/#contact">Liên hệ</a>
              <a href="/Account">{account?.user?.name || "Tài khoản"}</a>
              {isAdmin && <a href="/Admin/Users">Admin</a>}
            </nav>
            <a className="nav-cta" href="/KTool">
              Cài đặt ngay
            </a>
          </header>

          <section className="drafting-hero">
            <p className="eyebrow">{currentRoute.eyebrow}</p>
            <h1>{currentRoute.title}</h1>
            <p>{currentRoute.text}</p>
            <div className="hero-actions">
              <a className="primary-button" href="/#contact">
                Gửi dự án cần triển khai
              </a>
              <a className="secondary-button" href="/Learn">
                Xem khóa Revit MEPF
              </a>
            </div>
          </section>

          <section className="drafting-section">
            <div className="section-heading">
              <p className="eyebrow">Dịch vụ bao gồm</p>
              <h2>Triển khai BIM MEPF từ model đến hồ sơ thi công</h2>
            </div>
            <div className="drafting-service-grid">
              {currentRoute.services.map((item) => (
                <article className="drafting-card" key={item}>
                  <span>MEP</span>
                  <h3>{item}</h3>
                </article>
              ))}
            </div>
          </section>

          <section className="drafting-process">
            <div>
              <p className="eyebrow">Quy trình thực hiện</p>
              <h2>Làm rõ đầu vào, phối hợp mô hình, bàn giao đầy đủ</h2>
              <ol className="process-list">
                {currentRoute.process.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ol>
            </div>
          </section>

          <section className="drafting-summary">
            <aside className="support-card">
              <p className="eyebrow">Nhận outsource</p>
              <ul>
                {currentRoute.outsource.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </aside>
            <aside className="support-card">
              <p className="eyebrow">Đối tượng khách hàng</p>
              <ul>
                {currentRoute.customers.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </aside>
          </section>
        </main>
      );
    }

    if (normalizedPath === "/Learn") {
      return (
        <main className="site-shell">
          <header className="topbar">
            <a className="brand" href="/" aria-label="KTool home">
              <img className="brand-logo" src="/LogoKTool3D.jpg" alt="KTool logo" />
              <span>
                <strong>KTool Addin</strong>
                <small>Design & Drafting</small>
              </span>
            </a>
            <nav className="nav-links" aria-label="Điều hướng chính">
              <a href="/#services">Dịch vụ</a>
              <a href="/#pricing">Bảng giá</a>
              <a href="/Posts">Bài viết</a>
              <a href="/#contact">Liên hệ</a>
              <a href="/Account">{account?.user?.name || "Tài khoản"}</a>
              {isAdmin && <a href="/Admin/Users">Admin</a>}
            </nav>
            <a className="nav-cta" href="/KTool">
              Cài đặt ngay
            </a>
          </header>

          <section className="course-hero">
            <div className="course-hero-copy">
              <p className="eyebrow">{currentRoute.eyebrow}</p>
              <h1>{currentRoute.title}</h1>
              <p className="course-subtitle">{currentRoute.subtitle}</p>
              <p>{currentRoute.text}</p>
              <div className="hero-actions">
                <a className="primary-button" href="/Account?plan=LearnCourse">
                  Đăng ký ngay
                </a>
                <a className="primary-button" href={`tel:${currentRoute.contact.hotline}`}>
                  Gọi tư vấn
                </a>
                <a className="secondary-button" href={`mailto:${currentRoute.contact.email}`}>
                  Gửi email
                </a>
              </div>
            </div>
            <div className="course-image-grid" aria-label="Hình ảnh khóa học Revit MEPF">
              {currentRoute.images.map((image) => (
                <figure className="course-image-card" key={image.src}>
                  <button
                    aria-label={`Xem lớn ${image.alt}`}
                    onClick={() => setActiveImage(image)}
                    type="button"
                  >
                    <img alt={image.alt} src={image.src} />
                  </button>
                </figure>
              ))}
            </div>
          </section>

          {activeImage && (
            <div
              className="image-lightbox"
              onClick={() => setActiveImage(null)}
              role="presentation"
            >
              <button
                aria-label="Đóng ảnh"
                className="lightbox-close"
                onClick={() => setActiveImage(null)}
                type="button"
              >
                X
              </button>
              <img
                alt={activeImage.alt}
                onClick={(event) => event.stopPropagation()}
                src={activeImage.src}
              />
            </div>
          )}

          <section className="course-section">
            <div className="section-heading">
              <p className="eyebrow">Nội dung đào tạo</p>
              <h2>Lộ trình học từ nền tảng đến triển khai thực tế</h2>
            </div>
            <div className="module-grid">
              {currentRoute.modules.map((module, index) => (
                <article className="module-card" key={module.title}>
                  <span className="module-index">{String(index + 1).padStart(2, "0")}</span>
                  <h3>{module.title}</h3>
                  <ul>
                    {module.items.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </article>
              ))}
            </div>
          </section>

          <section className="course-summary">
            <div>
              <p className="eyebrow">Kết quả đạt được</p>
              <h2>Sẵn sàng làm việc với dự án BIM MEPF</h2>
              <ul className="check-list">
                {currentRoute.outcomes.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
            <aside className="support-card">
              <p className="eyebrow">Dịch vụ hỗ trợ</p>
              <ul>
                {currentRoute.support.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
              <div className="contact-lines">
                <a href={`tel:${currentRoute.contact.hotline}`}>Hotline: {currentRoute.contact.hotline}</a>
                <a href={`mailto:${currentRoute.contact.email}`}>Email: {currentRoute.contact.email}</a>
                <span>Website: {currentRoute.contact.website}</span>
              </div>
            </aside>
          </section>
        </main>
      );
    }

    return (
      <main className="site-shell">
        <header className="topbar">
          <a className="brand" href="/" aria-label="KTool home">
            <img className="brand-logo" src="/LogoKTool3D.jpg" alt="KTool logo" />
            <span>
              <strong>KTool Addin</strong>
              <small>Design & Drafting</small>
            </span>
          </a>
          <nav className="nav-links" aria-label="Điều hướng chính">
            <a href="/#services">Dịch vụ</a>
            <a href="/#pricing">Bảng giá</a>
            <a href="/Posts">Bài viết</a>
            <a href="/#contact">Liên hệ</a>
            <a href="/Account">{account?.user?.name || "Tài khoản"}</a>
            {isAdmin && <a href="/Admin/Users">Admin</a>}
          </nav>
          <a className="nav-cta" href="/KTool">
            Cài đặt ngay
          </a>
        </header>

        <section className="detail-page">
          <p className="eyebrow">{currentRoute.eyebrow}</p>
          <h1>{currentRoute.title}</h1>
          <p>{currentRoute.text}</p>
          <div className="hero-actions">
            <a className="primary-button" href="/#contact">
              Liên hệ tư vấn
            </a>
            <a className="secondary-button" href="/">
              Về trang chủ
            </a>
          </div>
        </section>
      </main>
    );
  }

  return (
    <main className="site-shell">
      <header className="topbar">
        <a className="brand" href="#top" aria-label="KTool home">
          <img className="brand-logo" src="/LogoKTool3D.jpg" alt="KTool logo" />
          <span>
            <strong>KTool Addin</strong>
            <small>Design & Drafting</small>
          </span>
        </a>
        <nav className="nav-links" aria-label="Điều hướng chính">
          <a href="#services">Dịch vụ</a>
          <a href="#pricing">Bảng giá</a>
          <a href="/Posts">Bài viết</a>
          <a href="#contact">Liên hệ</a>
          <a href="/Account">{account?.user?.name || "Tài khoản"}</a>
          {isAdmin && <a href="/Admin/Users">Admin</a>}
        </nav>
        <a className="nav-cta" href="/KTool">
          Cài đặt ngay
        </a>
      </header>

      <section className="hero" id="top">
        <div className="hero-copy">
          <p className="eyebrow">{site.hero.eyebrow}</p>
          <h1>{site.hero.title}</h1>
          <p className="hero-description">{site.hero.description}</p>
          <div className="hero-actions">
            <a className="primary-button" href="#services">
              {site.hero.primaryAction}
            </a>
            <a className="secondary-button" href="#contact">
              {site.hero.secondaryAction}
            </a>
          </div>
          <div className="stats-row">
            {site.hero.stats.map((stat) => (
              <div className="stat" key={stat.label}>
                <strong>{stat.value}</strong>
                <span>{stat.label}</span>
              </div>
            ))}
          </div>
          <div className="hero-advisors">
            <p>Hỗ trợ tư vấn chuyên môn:</p>
            <span>
              TS. <strong>Bùi Mai Cường</strong> (Giảng viên ngành Công Nghệ Kỹ thuật Nhiệt - Trường ĐH Sư Phạm Kỹ Thuật - ĐHĐN)
            </span>
            <span>
              KS. <strong>Từ Hồng Văn</strong>
            </span>
          </div>
        </div>
        <button
          className="hero-visual"
          aria-label="Phóng to KTool preview"
          onClick={() => setActiveImage({ src: "/Pic1.png", alt: "KTool preview" })}
          type="button"
        >
          <img className="hero-image" src="/Pic1.png" alt="KTool preview" />
        </button>
      </section>

      <section className="section services-section" id="services">
        <div className="section-heading">
          <p className="eyebrow">Dịch vụ của chúng tôi</p>
          <h2>
            Bộ giải pháp hỗ trợ làm việc với <span>Revit</span>
          </h2>
          <p>
          </p>
        </div>
        <div className="service-grid">
          {site.services.map((service) => (
            <article className="service-card service-link-card" key={service.title}>
              <a className="service-content-link" href={serviceRoutes[service.icon] || "/"}>
                <span className="service-icon">
                  <img alt="" src={serviceIconImages[service.icon] || "/Install.png"} />
                  <small>{iconMap[service.icon] || "KT"}</small>
                </span>
              </a>
              <h3>{service.title}</h3>
              <p>{service.text}</p>
              {servicePreviewImages[service.icon] && (
                <button
                  className="service-preview-button"
                  aria-label={`Phóng to ${service.title}`}
                  onClick={() =>
                    setActiveImage({
                      src: servicePreviewImages[service.icon],
                      alt: service.title,
                    })
                  }
                  type="button"
                >
                  <img alt={service.title} src={servicePreviewImages[service.icon]} />
                </button>
              )}
              <a className="service-card-action" href={serviceRoutes[service.icon] || "/"}>
                Xem chi tiết
              </a>
            </article>
          ))}
        </div>
      </section>

      {activeImage && (
        <div
          className="image-lightbox"
          onClick={() => setActiveImage(null)}
          role="presentation"
        >
          <button
            aria-label="Đóng ảnh"
            className="lightbox-close"
            onClick={() => setActiveImage(null)}
            type="button"
          >
            X
          </button>
          <img
            alt={activeImage.alt}
            onClick={(event) => event.stopPropagation()}
            src={activeImage.src}
          />
        </div>
      )}

      <section className="section pricing-section" id="pricing">
        <div className="section-heading">
          <p className="eyebrow">Chọn gói phần mềm</p>
          <h2>Giải pháp tối ưu cho Revit</h2>
          {highlightedPlan && <p>Gói được đề xuất: {highlightedPlan.name}</p>}
        </div>
        <div className="pricing-grid">
          {site.pricing.map((plan) => {
            const planKey = getPricingPlanKey(plan);
            const buttonText = planKey === "Free" ? "Đăng ký miễn phí" : "Đăng ký";

            return (
              <article className={`price-card ${plan.highlighted ? "highlighted" : ""}`} key={plan.name}>
                <span className="plan-name">{plan.name}</span>
                <strong>{plan.price}</strong>
                <p>{plan.note}</p>
                <ul>
                  {plan.features.map((feature) => (
                    <li key={feature}>{feature}</li>
                  ))}
                </ul>
                <a href={`/Account?plan=${planKey}`}>{buttonText}</a>
              </article>
            );
          })}
        </div>
      </section>

      <section className="proof-band">
        <div className="proof-heading">
          <div>
            <p className="eyebrow">Khách hàng & học viên</p>
            <h2>Người dùng nói gì về công cụ</h2>
          </div>
        </div>
        {showReviewForm && account?.user && (
          <form className="review-form" onSubmit={submitReview}>
            <label>
              Tên
              <input name="name" onChange={handleReviewChange} value={reviewForm.name} />
            </label>
            <label>
              Công việc
              <input name="role" onChange={handleReviewChange} placeholder="VD: Kỹ sư BIM, Kiến trúc sư..." value={reviewForm.role} />
            </label>
            <label>
              Nội dung
              <textarea name="quote" onChange={handleReviewChange} rows="3" value={reviewForm.quote} />
            </label>
            <button type="submit">{editingReviewId ? "Cập nhật" : "Gửi đánh giá"}</button>
          </form>
        )}
        {reviewStatus.message && (
          <p className={`form-status ${reviewStatus.type}`}>{reviewStatus.message}</p>
        )}
        <div className="testimonial-carousel">
          <button
            aria-label="Xem đánh giá phía trước"
            className="testimonial-arrow left"
            type="button"
            onClick={() => scrollTestimonials(-1)}
          >
            ‹
          </button>
          <div className="testimonial-track" ref={testimonialTrackRef}>
            {site.testimonials.map((item) => {
              const canEditReview = account?.user?.id && item.userId === account.user.id;

              return (
                <blockquote key={item.id || item.name}>
                  <p>"{item.quote}"</p>
                  <cite>
                    <strong>{item.name}</strong>
                    <span>{item.role}</span>
                  </cite>
                  {(canEditReview || isAdmin) && (
                    <div className="testimonial-actions">
                      {canEditReview && (
                        <button type="button" onClick={() => openReviewForm(item)}>
                          Sửa
                        </button>
                      )}
                      {isAdmin && (
                        <button className="danger" type="button" onClick={() => deleteReview(item)}>
                          Xoá
                        </button>
                      )}
                    </div>
                  )}
                </blockquote>
              );
            })}
          </div>
          <button
            aria-label="Xem đánh giá tiep theo"
            className="testimonial-arrow right"
            type="button"
            onClick={() => scrollTestimonials(1)}
          >
            ›
          </button>
        </div>
        <div className="proof-actions">
          <button
            className="review-toggle-button"
            type="button"
            onClick={() => {
              if (showReviewForm) {
                setShowReviewForm(false);
                setEditingReviewId(null);
                return;
              }
              openReviewForm();
            }}
          >
            Đánh giá
          </button>
        </div>
      </section>

      <section className="section content-contact">
        <div className="posts-panel">
          <p className="eyebrow">Bài viết mới nhất</p>
          <div className="post-list">
            {homePosts.map((post) => (
              <a className="post-link-card" href={`/Posts/${createPostSlug(post.title)}`} key={post.title}>
                <span>{post.tag}</span>
                <h3>{post.title}</h3>
                <p>{post.excerpt}</p>
                <time dateTime={post.date}>{post.date}</time>
              </a>
            ))}
          </div>
          {totalPostPages > 1 && (
            <nav className="pagination home-pagination" aria-label="Phân trang bài viết">
              {Array.from({ length: totalPostPages }, (_, index) => index + 1).map((page) => (
                <a href={`/Posts?page=${page}`} key={page}>
                  {page}
                </a>
              ))}
            </nav>
          )}
        </div>

        <form className="contact-form" id="contact" onSubmit={submitLead}>
          <p className="eyebrow">Liên hệ</p>
          <h2>Bạn muốn tự động hóa quy trình nào?</h2>
          <label>
            Họ tên
            <input name="name" onChange={handleLeadChange} required value={lead.name} />
          </label>
          <label>
            Email
            <input name="email" onChange={handleLeadChange} required type="email" value={lead.email} />
          </label>
          <label>
            Số điện thoại
            <input name="phone" onChange={handleLeadChange} value={lead.phone} />
          </label>
          <label>
            Nhu cầu
            <textarea
              name="need"
              onChange={handleLeadChange}
              required
              rows="4"
              value={lead.need}
            />
          </label>
          <button type="submit">Gửi yêu cầu</button>
          {status.message && <p className={`form-status ${status.type}`}>{status.message}</p>}
          <div className="contact-socials" aria-label="Liên kết liên hệ">
            <a href="https://zalo.me/0969860511" target="_blank" rel="noreferrer" aria-label="Zalo">
              <img src="/icons8-zalo-100.png" alt="Zalo" />
            </a>
            <a href="https://www.facebook.com/KToolAddin" target="_blank" rel="noreferrer" aria-label="Facebook">
              <img src="/icons8-facebook-100.png" alt="Facebook" />
            </a>
            <a href="https://www.youtube.com/@laotamk3" target="_blank" rel="noreferrer" aria-label="YouTube">
              <img src="/icons8-youtube-100.png" alt="YouTube" />
            </a>
            <a href="https://www.tiktok.com/@laotamk" target="_blank" rel="noreferrer" aria-label="TikTok">
              <img src="/icons8-tiktok-100.png" alt="TikTok" />
            </a>
            <a href="mailto:vantu1236744@gmail.com" aria-label="Email">
              <img src="/icons8-gmail-100.png" alt="Email" />
            </a>
          </div>
        </form>
      </section>

      <footer className="footer">
        <span>© 2026 KTool - Revit Add-ins. All rights reserved.</span>
        <span>Made with ❤️ by LaoTamK</span>
      </footer>
    </main>
  );
}

export default App;
